<div class="content-page" [attr.inert]="serverConfigurationOpen() ? '' : null" [style.--template-header-height.px]="headerHeight()" [class.template-source-page]="!!id && ((section==='templates' && (tab==='compose' || tab==='template-apache')) || (section==='services' && tab==='compose'))" [class.server-detail-page]="section==='servers' && !!id" [class.template-detail-page]="section==='templates' && !!id" [attr.aria-busy]="loading()" [style.padding-bottom.px]="feedbackHeight() ? feedbackHeight() + 32 : null">
  <wiz-dashboard
    #dashboard
    *ngIf="section==='dashboard'"
    [refresh]="dashboardRefresh"
  ></wiz-dashboard>
  <ng-container *ngIf="section==='system'">
    <div class="system-settings">
      <nav class="tabs system-tabs" role="tablist" aria-label="시스템 설정">
        <button *ngFor="let item of systemTabs; let index=index" type="button" role="tab"
          [id]="'system-tab-'+item.id" [attr.aria-controls]="'system-panel-'+item.id"
          [attr.aria-selected]="systemTab()===item.id" [attr.tabindex]="systemTab()===item.id ? 0 : -1"
          [class.active]="systemTab()===item.id" (click)="selectSystemTab(item.id)" (keydown)="systemTabKey($event,index)">
          <wiz-icon [name]="item.icon"></wiz-icon>{{ item.label }}
        </button>
      </nav>
      <div id="system-panel-general" class="system-panel system-general-grid" role="tabpanel" aria-labelledby="system-tab-general" tabindex="0" [hidden]="systemTab()!=='general'">
        <section class="panel settings-card">
          <div class="panel-header">
            <h2>워크스페이스 설정</h2>
            <wiz-icon name="settings"></wiz-icon>
          </div>
          <div class="panel-body">
            <form (ngSubmit)="saveSettings()">
              <p class="muted">서비스를 운영할 기본 환경을 설정합니다.</p>
              <label class="field"
                >워크스페이스 이름<input
                  name="title"
                  [(ngModel)]="settings()['title']"
                  required
                  maxlength="80" /></label
              >
              <label class="field">
                <span class="settings-field-label">세션 유지 시간 (분) <small>5~35,791,394분</small></span>
                <input name="sessionTimeoutMinutes" type="number" min="5" max="35791394" step="1"
                  [(ngModel)]="settings()['sessionTimeoutMinutes']" required />
              </label>
              <button class="button primary" type="submit" [disabled]="busy()">
                <wiz-icon name="save"></wiz-icon>설정 저장
              </button>
            </form>
            <div class="settings-divider">
              <h3>관리자 비밀번호</h3>
              <p class="muted">
                비밀번호를 변경하면 다른 로그인 세션이 종료됩니다.
              </p>
              <button class="button" (click)="changePassword()">
                <wiz-icon name="lock"></wiz-icon>비밀번호 변경
              </button>
            </div>
          </div>
        </section>
        <section class="panel settings-card">
          <div class="panel-header">
            <h2>워크스페이스 브랜딩</h2>
            <wiz-icon name="layout"></wiz-icon>
          </div>
          <div class="panel-body">
            <div class="brand-preview">
              <img
                [src]="appearance()['logoUrl'] || '/assets/brand/symbol.svg'"
                alt="현재 심볼"
                width="64"
                height="64"
              />
              <p class="muted">
                심볼 하나로 사이드바 로고와 브라우저 아이콘을 만듭니다.
              </p>
            </div>
            <label class="upload-tile"
              ><wiz-icon name="upload"></wiz-icon
              ><span
                >심볼 이미지<input
                  type="file"
                  accept="image/png,image/jpeg"
                  (change)="uploadAppearance($event,'symbol')"
                  aria-label="심볼 이미지 업로드"
                /><small
                  >PNG · JPEG, 최대 1MB · 크기와 비율 자동 조정</small
                ></span
              ></label
            >
            <p class="small-note">이미지를 업로드하면 바로 적용됩니다. 브라우저와 사이드바 제목은 워크스페이스 이름을 따릅니다.</p>
          </div>
        </section>
        <section class="panel settings-card system-runtime-card">
          <div class="panel-header"><h2>실행 환경</h2></div>
          <div class="panel-body">
            <dl class="definition-list runtime-values">
              <div class="runtime-path"><dt>서비스 저장 경로</dt><dd>{{ settings()['serviceRoot'] || '확인 불가' }}</dd></div>
              <div>
                <dt>Java</dt>
                <dd>{{ health()['javaVersion'] || '확인 불가' }}</dd>
              </div>
              <div>
                <dt>Spring Framework</dt>
                <dd>{{ health()['springVersion'] || '확인 불가' }}</dd>
              </div>
              <div>
                <dt>PostgreSQL</dt>
                <dd>{{ health()['postgresqlVersion'] || '확인 불가' }}</dd>
              </div>
              <div>
                <dt>Redis</dt>
                <dd>{{ health()['redisVersion'] || '확인 불가' }}</dd>
              </div>
            </dl>
          </div>
        </section>
      </div>
      <div id="system-panel-dns" class="system-panel" role="tabpanel" aria-labelledby="system-tab-dns" tabindex="0" [hidden]="systemTab()!=='dns'">
        <section class="panel settings-card">
          <div class="panel-header"><h2>DNS 연결 주소</h2><wiz-icon name="globe"></wiz-icon></div>
          <div class="panel-body">
            <form (ngSubmit)="saveDnsTargets()">
              <p class="muted">서비스 도메인이 연결될 Apache 서버의 공인 IP 또는 도메인을 관리합니다.</p>
              <label class="field">IP·도메인 목록
                <textarea name="dnsAddresses" [(ngModel)]="dnsAddressesText" (ngModelChange)="dnsAddressesChanged()" rows="6" placeholder="203.0.113.10&#10;proxy.example.com"></textarea>
                <small>한 줄에 주소 하나씩 입력하세요.</small>
              </label>
              <label class="field">기본 연결 주소
                <select name="dnsDefaultAddress" [(ngModel)]="dnsDefaultAddress">
                  <option value="">기본값 없음</option>
                  <option *ngFor="let address of dnsAddressOptions" [value]="address">{{ address }}</option>
                </select>
              </label>
              <button class="button primary" type="submit" [disabled]="busy()"><wiz-icon name="save"></wiz-icon>주소 목록 저장</button>
            </form>
          </div>
        </section>
      </div>
      <div id="system-panel-agent" class="system-panel" role="tabpanel" aria-labelledby="system-tab-agent" tabindex="0" [hidden]="systemTab()!=='agent'">
        <div class="notice error" *ngIf="agentError()" role="alert">{{ agentError() }} 현재 상태를 다시 확인해 주세요.</div>
        <section class="panel settings-card">
          <div class="panel-header">
            <h2>연결 및 인증</h2>
            <button class="button" (click)="refreshAgentStatus(true)" [disabled]="agentChecking() || busy() || maintenanceActive">
              <wiz-icon name="refresh"></wiz-icon>{{ agentChecking() ? '확인 중…' : '인증 상태 확인' }}
            </button>
          </div>
          <div class="panel-body" [attr.aria-busy]="agentChecking()">
            <div class="agent-status-grid">
              <div><span>Agent 사용</span><strong>{{ agentStatus()['enabled'] === undefined ? '확인 전' : agentStatus()['enabled'] ? '사용 중' : '사용 안 함' }}</strong></div>
              <div><span>CLI 설치</span><strong>{{ agentStatus()['binaryAvailable'] === undefined ? '확인 전' : agentStatus()['binaryAvailable'] ? '설치됨' : '설치 필요' }}</strong></div>
              <div><span>계정 인증</span><strong class="badge" [ngClass]="agentStatus()['authStatus']==='authenticated' ? 'success' : agentStatus()['authStatus']==='error' ? 'danger' : 'neutral'">{{ agentAuthLabel(agentStatus()['authStatus']) }}</strong></div>
            </div>
            <p class="muted" role="status">{{ agentStatus()['message'] || 'Agent 상태를 확인하고 있습니다.' }}</p>
            <div class="agent-connection-actions">
              <button class="button primary" (click)="startMaintenance('login')" [disabled]="busy() || maintenanceActive || !agentStatus()['binaryAvailable']">{{ agentStatus()['loginConfigured'] ? '다시 로그인' : '기기 로그인' }}<wiz-icon name="external"></wiz-icon></button>
              <span class="small-note" *ngIf="agentStatus()['authMethod']">인증 방식 · {{ agentStatus()['authMethod'] }}</span>
              <span class="small-note" *ngIf="agentStatus()['checkedAt']">마지막 확인 · {{ date(agentStatus()['checkedAt']) }}</span>
            </div>
            <dl class="definition-list agent-paths"><div><dt>실행 파일</dt><dd>{{ agentStatus()['binaryPath'] || '확인 중' }}</dd></div><div><dt>인증 경로</dt><dd>{{ agentStatus()['authHome'] || '확인 중' }}</dd></div></dl>
            <p class="small-note">표시된 인증 경로에 저장된 CLI 로그인 상태를 확인합니다. 모델 접근 권한과 실제 호출 가능 여부는 Agent 실행 시 확인됩니다.</p>
          </div>
        </section>
        <div class="agent-settings-grid">
        <section class="panel settings-card">
          <div class="panel-header"><h2>모델과 추론</h2><button class="button" (click)="editAgentSettings()" [disabled]="busy()"><wiz-icon name="settings"></wiz-icon>Agent 설정</button></div>
          <div class="panel-body">
            <dl class="definition-list"><div><dt>모델</dt><dd>{{ agentStatus()['model'] || '미설정' }}</dd></div><div><dt>추론 수준</dt><dd>{{ reasoningLabel(agentStatus()['reasoning']) }}</dd></div></dl>
            <p class="small-note">일반 Agent 대화의 기본 설정입니다. Apache 설정 초안과 서버 점검 분석은 {{ reasoningLabel('low') }}으로 실행됩니다.</p>
          </div>
        </section>
        <section class="panel settings-card">
          <div class="panel-header"><h2>설치 및 업데이트</h2><span class="badge neutral">npm · @openai/codex</span></div>
          <div class="panel-body">
            <dl class="definition-list"><div><dt>설치 위치</dt><dd>{{ agentStatus()['installationSource'] || '확인 중' }}</dd></div><div><dt>설치 버전</dt><dd>{{ agentStatus()['version'] || (agentStatus()['binaryAvailable'] ? '확인 실패' : '미설치') }}</dd></div></dl>
            <p class="muted">기존 서버 npm 설치를 자동으로 찾습니다. 업데이트는 앱 관리 경로에 검증 후 적용하며 로그인과 대화 기록은 유지됩니다.</p>
            <div class="agent-connection-actions">
              <button class="button" type="button" (click)="checkAgentVersion()" [disabled]="agentVersionChecking() || busy() || maintenanceActive"><wiz-icon name="search"></wiz-icon>{{ agentVersionChecking() ? '최신 버전 확인 중…' : '최신 버전 확인하기' }}</button>
            </div>
            <div class="notice error" role="alert" *ngIf="agentVersionError()">{{ agentVersionError() }}</div>
            <div class="agent-version-result" *ngIf="agentRelease() as release" role="status">
              <dl class="definition-list"><div><dt>최신 버전</dt><dd>{{ release['version'] }}</dd></div><div><dt>확인 시각</dt><dd>{{ date(release['checkedAt']) }}</dd></div></dl>
              <p class="small-note">{{ agentVersionMessage }}</p>
              <button class="button primary" type="button" *ngIf="agentVersionCanInstall" (click)="startMaintenance(agentStatus()['binaryAvailable'] ? 'update' : 'install')" [disabled]="busy() || agentChecking() || maintenanceActive || !agentStatus()['npmAvailable'] || !agentStatus()['updateAvailable']">{{ release['version'] }} {{ agentStatus()['binaryAvailable'] ? '버전으로 업데이트' : '버전 설치' }}</button>
            </div>
            <p class="small-note" *ngIf="agentStatus()['updateAvailable']===false">지정한 외부 실행 파일은 해당 설치 환경에서 업데이트하세요.</p>
            <p class="small-note" *ngIf="agentStatus()['npmAvailable']===false">설치·업데이트하려면 서버에 Node.js와 npm이 필요합니다.</p>
          </div>
        </section>
        </div>
      </div>
      <div id="system-panel-mail" class="system-panel" role="tabpanel" aria-labelledby="system-tab-mail" tabindex="0" [hidden]="systemTab()!=='mail'">
        <section class="panel settings-card">
          <div class="panel-header">
            <h2>SMTP 메일 설정</h2>
            <wiz-icon name="inbox"></wiz-icon>
          </div>
          <div class="panel-body">
            <p class="muted">
              리포트와 알림을 보낼 메일 서버를 설정합니다. 보안 연결 방식은
              포트에 맞춰 자동으로 적용됩니다.
            </p>
            <form *ngIf="smtp()['smtpPort']" #smtpForm="ngForm" (ngSubmit)="saveSmtp()">
              <label class="checkbox-label smtp-enabled"><input type="checkbox" name="mailEnabled" [(ngModel)]="smtp()['mailEnabled']" />메일 발송 사용</label>
              <div class="form-grid">
                <label class="field">SMTP 서버<input name="smtpHost" [(ngModel)]="smtp()['smtpHost']" [required]="smtp()['mailEnabled']" placeholder="smtp.example.com" /></label>
                <label class="field">SMTP 포트<input name="smtpPort" type="number" min="1" max="65535" step="1" [(ngModel)]="smtp()['smtpPort']" required /><small>465: TLS · 그 외: STARTTLS</small></label>
                <label class="field">SMTP 계정 (이메일)<input name="smtpUsername" type="email" email [(ngModel)]="smtp()['smtpUsername']" [required]="smtp()['mailEnabled']" autocomplete="off" /><small>이 계정을 발신 주소로 사용합니다.</small></label>
                <label class="field">SMTP 비밀번호<input name="smtpPassword" type="password" [(ngModel)]="smtp()['smtpPassword']" autocomplete="new-password" [placeholder]="smtp()['smtpPasswordConfigured'] ? '저장된 비밀번호 유지' : 'SMTP 비밀번호 입력'" /><small>{{ smtp()['smtpPasswordConfigured'] ? '변경할 때만 입력하세요. 비워 두면 기존 비밀번호를 유지합니다.' : '메일 서버에서 발급한 비밀번호를 입력하세요.' }}</small></label>
                <label class="field span-full">발신 이름<input name="smtpSenderName" maxlength="120" [(ngModel)]="smtp()['smtpSenderName']" /></label>
              </div>
              <p class="small-note">리포트 수신자는 <a routerLink="/reports" class="text-link">리포트 설정</a>에서 관리합니다. 테스트 메일은 저장된 설정으로 발송됩니다.</p>
              <div class="toolbar-left">
                <button class="button primary" type="submit" [disabled]="busy() || smtpForm.invalid"><wiz-icon name="save"></wiz-icon>SMTP 설정 저장</button>
                <button class="button" type="button" (click)="testMail()" [disabled]="busy()"><wiz-icon name="inbox"></wiz-icon>테스트 메일 발송</button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="section!=='dashboard' && section!=='system' && !id">
    <div class="tabs" *ngIf="section==='domains'">
      <button
        [class.active]="tab!=='apache-host'"
        (click)="selectTab('overview')"
      >
        <wiz-icon name="globe"></wiz-icon>DNS 레코드</button
      ><button
        [class.active]="tab==='apache-host'"
        (click)="selectTab('apache-host')"
      >
        <wiz-icon name="server"></wiz-icon>Apache2 웹서버 설정
      </button>
    </div>
    <div class="notice" *ngIf="section==='servers'">
      <wiz-icon name="shield"></wiz-icon
      ><span
        >현재 서버는 로컬 명령으로 자동 연결됩니다. 원격 서버는 패스워드 또는
        개인키로 등록하며 배포 대상은 직접 선택합니다.</span
      >
    </div>
    <div
      class="dns-zone-navigation"
      *ngIf="section==='domains' && tab!=='apache-host'"
    >
      <div class="dns-zone-tabs" role="tablist" aria-label="등록된 도메인">
        <button
          type="button"
          role="tab"
          *ngFor="let zone of zones()"
          [class.active]="selectedZone===zone['id']"
          [attr.aria-selected]="selectedZone===zone['id']"
          [disabled]="busy()"
          (click)="chooseZone(zone['id'])"
        >
          <wiz-icon name="globe" aria-hidden="true"></wiz-icon>
          <span>{{ zone['name'] }}</span>
        </button>
        <span class="dns-zone-empty" *ngIf="!zones().length"
          >등록된 도메인이 없습니다.</span
        >
      </div>
      <div class="dns-summary-actions">
        <button class="button" [disabled]="!selectedZone || busy()" (click)="manageZone()"><wiz-icon name="settings"></wiz-icon>DNS 영역 관리</button>
        <button class="button primary" (click)="connectZone()"><wiz-icon name="plus"></wiz-icon>DNS 영역 연결</button>
      </div>
    </div>
    <div
      class="toggle-filter"
      *ngIf="section==='domains' && tab!=='apache-host'"
      role="group"
      aria-label="DNS 레코드 유형 필터"
    >
      <button
        type="button"
        [class.active]="dnsType===''"
        (click)="dnsType='';resetPage()"
      >
        전체</button
      ><button
        type="button"
        *ngFor="let type of dnsTypes"
        [class.active]="dnsType===type"
        (click)="dnsType=type;resetPage()"
      >
        {{ type }}
      </button>
    </div>
    <div class="notice" *ngIf="section==='images'">
      <wiz-icon name="layers"></wiz-icon
      ><span
        >선택한 로컬 또는 원격 서버의 Docker 이미지를 조회합니다. 실행 중이거나
        배포 이력에서 참조하는 이미지는 보호됩니다.</span
      >
    </div>
    <div class="summary-strip" *ngIf="section==='reports'">
      <button class="text-link" (click)="healthResults()">
        <wiz-icon name="activity"></wiz-icon>서비스 상태 관측</button
      ><button
        class="text-link"
        (click)="confirmAction('서비스 상태 점검','등록된 서비스의 실제 Docker 상태를 조회합니다.','/service-health/runs',{serviceId:''})"
      >
        <wiz-icon name="check"></wiz-icon>지금 상태 점검
      </button>
    </div>
    <div class="notice" *ngIf="section==='schedules'">
      <wiz-icon name="clock"></wiz-icon
      ><span
        >같은 대상의 충돌 작업과 중복 실행은 서버에서 확인합니다.</span
      >
    </div>
    <section class="panel" *ngIf="section!=='domains' || tab!=='apache-host'">
      <div
        class="toolbar"
        [class.schedules-toolbar]="section==='schedules'"
        [class.domain-toolbar]="section==='domains'"
        [class.operations-toolbar]="section==='operations'"
        [class.images-toolbar]="section==='images' || section==='services' || section==='templates'"
      >
        <div class="operation-filters" *ngIf="section==='operations'">
          <div class="operation-filter-row">
            <span id="operation-type-label" class="operation-filter-label">작업 종류</span>
            <div id="operation-type-options" class="toggle-filter" role="group" aria-labelledby="operation-type-label">
              <button type="button" [class.active]="!operationType" [attr.aria-pressed]="!operationType"
                [disabled]="loading()" (click)="setOperationFilter('type','')">전체</button>
              <button type="button" *ngFor="let type of visibleOperationTypes"
                [class.active]="operationType===type" [attr.aria-pressed]="operationType===type"
                [disabled]="loading()" (click)="setOperationFilter('type',type)">{{ opLabel(type) }}</button>
              <button type="button" class="filter-expand" [attr.aria-expanded]="operationTypesExpanded"
                aria-controls="operation-type-options" (click)="operationTypesExpanded=!operationTypesExpanded">
                {{ operationTypesExpanded ? '종류 접기' : '종류 더 보기' }}
              </button>
            </div>
          </div>
          <div class="operation-filter-row">
            <span id="operation-status-label" class="operation-filter-label">상태</span>
            <div class="toggle-filter" role="group" aria-labelledby="operation-status-label">
              <button type="button" [class.active]="!filter" [attr.aria-pressed]="!filter"
                [disabled]="loading()" (click)="setOperationFilter('status','')">전체</button>
              <button type="button" *ngFor="let value of operationStatuses"
                [class.active]="filter===value" [attr.aria-pressed]="filter===value"
                [disabled]="loading()" (click)="setOperationFilter('status',value)">{{ status(value) }}</button>
            </div>
          </div>
          <div class="operation-filter-row">
            <span id="operation-server-label" class="operation-filter-label">대상 서버</span>
            <div class="toggle-filter operation-server-options" role="group" aria-labelledby="operation-server-label">
              <button type="button" [class.active]="!operationServer" [attr.aria-pressed]="!operationServer"
                [disabled]="loading()" (click)="setOperationFilter('server','')">전체</button>
              <button type="button" *ngFor="let server of serverOptions"
                [class.active]="operationServer===server['id']" [attr.aria-pressed]="operationServer===server['id']"
                [disabled]="loading()" [title]="server['name']"
                (click)="setOperationFilter('server',server['id'])">{{ server['name'] }}</button>
              <button type="button" [class.active]="operationServer==='other'" [attr.aria-pressed]="operationServer==='other'"
                [disabled]="loading()" (click)="setOperationFilter('server','other')">기타</button>
            </div>
          </div>
        </div>
        <div class="report-filters" *ngIf="section==='reports'">
          <div class="toggle-filter" role="group" aria-label="리포트 주기">
            <button *ngFor="let period of reportPeriods" type="button" [class.active]="reportPeriod===period.value"
              [attr.aria-pressed]="reportPeriod===period.value" [disabled]="loading()"
              (click)="reportPeriod=period.value;reportFilterChanged()">{{ period.label }}</button>
          </div>
          <div class="report-date-filters" role="group" aria-label="리포트 분석 기간">
            <span class="report-filter-label">분석 기간</span>
            <label>시작일<input type="date" name="reportFrom" aria-label="리포트 시작일" [(ngModel)]="reportFrom"
              (ngModelChange)="reportFilterChanged()" [disabled]="loading()" /></label>
            <span aria-hidden="true">~</span>
            <label>종료일<input type="date" name="reportTo" aria-label="리포트 종료일" [(ngModel)]="reportTo"
              (ngModelChange)="reportFilterChanged()" [disabled]="loading()" /></label>
            <button class="button small" type="button" (click)="resetReportFilters()" [disabled]="loading() || !(reportPeriod || reportFrom || reportTo)">초기화</button>
          </div>
        </div>
        <div class="toolbar-left" *ngIf="!['operations','reports'].includes(section)">
          <label class="search-field"
            ><wiz-icon name="search"></wiz-icon
            ><input
              [(ngModel)]="search"
              (ngModelChange)="resetPage()"
              [placeholder]="title+(paged?' · 현재 페이지 검색':' 검색')"
              [attr.aria-label]="title+' 검색'" /></label
          ><select
            class="filter-select"
            [(ngModel)]="filter"
            (ngModelChange)="filterChanged()"
            *ngIf="['services','servers'].includes(section)"
            aria-label="상태 필터"
          >
            <option value="">모든 상태</option>
            <option
              *ngFor="let s of section==='services' ? ['draft','healthy','deploying','failed','stopped'] : ['connected','unverified','unreachable','degraded','stale']"
              [value]="s"
            >
              {{ status(s) }}
            </option></select
          ><select class="filter-select" *ngIf="section==='servers'" [(ngModel)]="serverSort" (ngModelChange)="serverSortChanged()" aria-label="서버 정렬 기준">
            <option value="name-asc">서버 이름 오름차순</option>
            <option value="name-desc">서버 이름 내림차순</option>
            <option value="score-asc">배포 점수 오름차순</option>
            <option value="score-desc">배포 점수 내림차순</option>
            <option value="host-asc">host 오름차순</option>
            <option value="host-desc">host 내림차순</option></select
          ><select
            class="filter-select image-server-select"
            *ngIf="section==='images'"
            [(ngModel)]="selectedServer"
            (ngModelChange)="page=1; loadImages()"
            aria-label="이미지를 조회할 서버"
          >
            <option value="">서버 선택</option>
            <option *ngFor="let server of serverOptions" [value]="server['id']">
              {{ server['name'] }}{{ server['executionMode']==='local' ? ' ·
              로컬 서버' : '' }}
            </option></select
          ><select
            class="filter-select"
            *ngIf="section==='images'"
            [(ngModel)]="filter"
            (ngModelChange)="filterChanged()"
            aria-label="이미지 사용 상태"
          >
            <option value="">모든 이미지</option>
            <option value="in-use">사용 중</option>
            <option value="unused">미사용</option>
            <option value="protected">보호됨</option></select
          ><select
            class="filter-select"
            *ngIf="section==='images'"
            [(ngModel)]="imageSort"
            aria-label="이미지 정렬"
          >
            <option value="size-desc">큰 용량순</option>
            <option value="recent">최근 사용순</option>
            <option value="name">이름순</option></select>
        </div>
        <div class="toolbar-right">
          <button class="button small primary" *ngIf="canCreate" (click)="openCreate()">
            <wiz-icon name="plus"></wiz-icon>{{ createLabel }}
          </button>
          <ng-container *ngIf="section==='services' && selectedServices().size"
            ><span class="count-label"
              >{{ selectedServices().size }}개 선택</span
            ><button class="button small" (click)="bulkServices('deploy')">
              <wiz-icon name="play"></wiz-icon>배포</button
            ><button class="button small" (click)="bulkServices('restart')">
              <wiz-icon name="refresh"></wiz-icon>재시작</button
            ><button class="button small" (click)="bulkServices('stop')">
              <wiz-icon name="stop"></wiz-icon>중지</button
            ><button
              class="button small danger"
              (click)="bulkServices('remove')"
            >
              <wiz-icon name="trash"></wiz-icon>제거
            </button></ng-container
          ><button
            class="button small"
            *ngIf="section==='templates'"
            (click)="agentTemplate()"
          >
            <wiz-icon name="spark"></wiz-icon>Agent로 초안 만들기</button
          ><ng-container *ngIf="section==='images'"
            ><button
              class="button small"
              *ngIf="selectedImages().size"
              (click)="selectedPrune()"
              [disabled]="imageWorking || loading()"
            >
              <wiz-icon name="trash"></wiz-icon>선택 {{ selectedImages().size
              }}개 삭제 검토</button
            ><button
              class="button small"
              [disabled]="!selectedServer || imageWorking || loading()"
              (click)="imagePull()"
            >
              <wiz-icon name="upload"></wiz-icon>이미지 가져오기</button
            ><button
              class="button small"
              [disabled]="!selectedServer || imageWorking || loading()"
              (click)="previewPrune()"
            >
              <wiz-icon name="trash"></wiz-icon>미사용 정리
            </button></ng-container
          ><span
            class="count-label"
            *ngIf="!['images','domains'].includes(section)"
            >{{ paged ? '현재 페이지' : '전체' }}
            <strong>{{ rows().length }}</strong></span
          ><ng-container *ngIf="section==='domains'">
            <div class="dns-last-sync" *ngIf="selectedZone">
              <span class="dns-last-sync-label">마지막 동기화</span>
              <span class="dns-last-sync-value" *ngIf="lastDnsSync as sync; else noDnsSync">
                <time [attr.datetime]="sync.datetime" title="한국 표준시 (KST)">{{ sync.absolute }}</time>
                <span class="dns-last-sync-relative">({{ sync.relative }})</span>
              </span>
              <ng-template #noDnsSync><span>동기화 기록 없음</span></ng-template>
            </div>
            <button
              class="button small"
              [disabled]="!selectedZone || busy() || !!operation()"
              (click)="syncZone()"
            >
              <wiz-icon name="refresh"></wiz-icon>동기화</button
            ><button
              class="button small"
              [disabled]="!selectedZone"
              (click)="openRecord()"
            >
              <wiz-icon name="plus"></wiz-icon>레코드 추가
            </button></ng-container
          ><button
            class="button small"
            *ngIf="section==='reports'"
            (click)="reportSettings()"
          >
            <wiz-icon name="settings"></wiz-icon>분석 설정
          </button
          ><button
            class="button small primary"
            *ngIf="section==='reports'"
            (click)="reportCreate()"
          >
            <wiz-icon name="plus"></wiz-icon>리포트 생성
          </button>
        </div>
      </div>
      <div class="loading-state" *ngIf="loading()">
        <span class="spinner"></span>{{ title }} 데이터를 불러오는 중입니다.
      </div>
      <div class="table-wrap" [class.template-table-wrap]="section==='templates'" *ngIf="displayed.length && !loading()">
        <table [class.operations-table]="section==='operations'" [class.templates-table]="section==='templates'">
          <thead>
            <tr [ngSwitch]="section">
              <ng-container *ngSwitchCase="'services'"
                ><th>
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    (change)="toggleAllServices()"
                    aria-label="현재 페이지 서비스 전체 선택"
                  />
                </th>
                <th>서비스</th>
                <th>상태</th>
                <th>실행 서버</th>
                <th>도메인</th>
                <th>최근 변경</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'servers'"
                ><th>서버</th>
                <th>연결 상태</th>
                <th>자원 사용률</th>
                <th>배포 점수</th>
                <th>최근 수집</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'templates'"
                ><th>템플릿</th>
                <th>분류</th>
                <th>입력값</th>
                <th>상태</th>
                <th>등록일</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'macros'"
                ><th>매크로</th>
                <th>버전</th>
                <th>최근 변경</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'schedules'"
                ><th>예약 작업</th>
                <th>실행 주기</th>
                <th>다음 실행</th>
                <th>최근 결과</th>
                <th>상태</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'operations'"
                ><th>작업</th>
                <th>대상</th>
                <th>상태</th>
                <th>시작 시각</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'reports'"
                ><th>리포트</th>
                <th>분석 기간</th>
                <th>상태</th>
                <th>생성 시각</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'domains'"
                ><th>유형 / 이름</th>
                <th>값</th>
                <th>TTL</th>
                <th></th></ng-container
              ><ng-container *ngSwitchCase="'images'"
                ><th>
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    aria-label="현재 페이지의 삭제 가능한 이미지 전체 선택"
                    (change)="selectAllImages()"
                    [disabled]="imageWorking"
                  />
                </th>
                <th>이미지 이름</th>
                <th>버전</th>
                <th>크기</th>
                <th>생성일</th>
                <th>사용 상태</th>
                <th></th
              ></ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of displayed" [ngSwitch]="section">
              <ng-container *ngSwitchCase="'services'"
                ><td>
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    [checked]="selectedServices().has(row['id'])"
                    (change)="toggleService(row)"
                    aria-label="일괄 작업할 서비스 선택"
                  />
                </td>
                <td>
                  <a [routerLink]="'/services/'+row['id']" class="table-name"
                    ><span class="surface-icon"
                      ><wiz-icon name="cube"></wiz-icon></span
                    ><span
                      ><strong>{{ row['name'] }}</strong
                      ><small
                        >구성 버전 {{ row['composeVersion'] || 1 }}</small
                      ></span
                    ></a
                  >
                </td>
                <td>
                  <span class="badge" [ngClass]="tone(row['status'])"
                    ><i></i>{{ status(row['status']) }}</span
                  >
                </td>
                <td>{{ row['serverName'] || serverName(row['serverId']) }}</td>
                <td>{{ row['domain'] || '연결 안 됨' }}</td>
                <td>{{ date(row['updatedAt']) }}</td>
                <td>
                  <button
                    class="icon-button"
                    (click)="open(row)"
                    aria-label="서비스 상세"
                  >
                    <wiz-icon name="chevron"></wiz-icon>
                  </button></td
              ></ng-container>
              <ng-container *ngSwitchCase="'servers'"
                ><td>
                  <a class="table-name" [routerLink]="'/servers/'+row['id']"
                    ><span class="surface-icon"
                      ><wiz-icon name="server"></wiz-icon></span
                    ><span
                      ><strong>{{ row['name'] }}</strong
                      ><small
                        >{{ row['executionMode']==='local' ? '로컬 명령 실행 ·
                        SSH 불필요' :
                        row['username']+'@'+row['host']+':'+row['port']
                        }}</small
                      ></span
                    ></a
                  >
                </td>
                <td>
                  <span class="badge" [ngClass]="tone(row['status'])"
                    ><i></i>{{ status(row['status']) }}</span
                  ><small *ngIf="row['isControlHost']">관리 콘솔 호스트</small>
                </td>
                <td>
                  <div class="metrics-inline">
                    <div
                      *ngFor="let metric of [{key:'cpuPercent',label:'CPU'},{key:'memoryPercent',label:'메모리'},{key:'storagePercent',label:'스토리지'}]"
                      class="resource-value"
                      [ngClass]="resourceTone(row[metric.key])"
                    >
                      {{ metric.label }} {{ percent(row[metric.key]) }}
                      <div class="metric-bar">
                        <i [style.width.%]="row[metric.key]||0"></i>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <strong>{{ row['score'] ?? '집계 대기' }}</strong
                  ><small
                    >{{ row['eligible'] ? '배포 가능' : '준비 필요' }}</small
                  >
                </td>
                <td>{{ date(row['metricAt']) }}</td>
                <td>
                  <button class="icon-button" [disabled]="busy() || !!operation()" (click)="serverCheck(row)" aria-label="연결 점검" title="연결 점검"><wiz-icon name="check"></wiz-icon></button>
                  <button class="icon-button danger" *ngIf="!row['isControlHost'] && row['executionMode']!=='local'" [disabled]="busy() || !!operation() || row['status']==='disconnecting'" (click)="deleteRow(row)" aria-label="서버 연결 해제" title="서버 연결 해제"><wiz-icon name="trash"></wiz-icon></button>
                  <button
                    class="icon-button"
                    (click)="open(row)"
                    [attr.aria-label]="row['eligible'] ? '서버 상세' : '서버 구성'"
                    [attr.title]="row['eligible'] ? '서버 상세' : '서버 구성'"
                  >
                    <wiz-icon name="chevron"></wiz-icon>
                  </button></td
              ></ng-container>
              <ng-container *ngSwitchCase="'templates'"
                ><td data-label="템플릿">
                  <a class="table-name" [routerLink]="'/templates/'+row['id']"
                    ><span class="surface-icon"
                      ><wiz-icon name="layout"></wiz-icon></span
                    ><span
                      ><strong>{{ row['name'] }}</strong
                      ><small
                        >{{ row['description'] || '설명 없음' }}</small
                      ></span
                    ></a
                  >
                </td>
                <td data-label="분류">{{ row['tags']?.join(', ') || '—' }}</td>
                <td data-label="입력값">기본 {{ templateFields(row).length }}개<small *ngIf="templateFields(row,true).length">고급 {{ templateFields(row,true).length }}개</small></td>
                <td data-label="상태">
                  <span
                    class="badge"
                    [ngClass]="row['enabled'] ? 'success' : 'neutral'"
                    >{{ row['enabled'] ? '사용 가능' : '비활성' }}</span
                  >
                </td>
                <td data-label="등록일">{{ date(row['createdAt']) }}</td>
                <td data-label="상세">
                  <button
                    class="icon-button"
                    (click)="open(row)"
                    aria-label="템플릿 상세"
                  >
                    <wiz-icon name="chevron"></wiz-icon>
                  </button></td
              ></ng-container>
              <ng-container *ngSwitchCase="'macros'"
                ><td>
                  <a class="table-name" [routerLink]="'/macros/'+row['id']"
                    ><span class="surface-icon"
                      ><wiz-icon name="terminal"></wiz-icon></span
                    ><span
                      ><strong>{{ row['name'] }}</strong
                      ><small
                        >{{ row['description'] || '설명 없음' }}</small
                      ></span
                    ></a
                  >
                </td>
                <td>v{{ row['version'] || 1 }}</td>
                <td>{{ date(row['updatedAt']) }}</td>
                <td>
                  <div class="row-actions">
                    <button
                      class="button small"
                      (click)="openMacroRun(row)"
                    >
                      <wiz-icon name="play"></wiz-icon>실행</button
                    ><button
                      class="icon-button"
                      (click)="openEdit(row)"
                      aria-label="매크로 수정"
                    >
                      <wiz-icon name="edit"></wiz-icon>
                    </button>
                  </div></td
              ></ng-container>
              <ng-container *ngSwitchCase="'schedules'"
                ><td>
                  <strong>{{ row['name'] }}</strong
                  ><small>{{ jobLabel(row['jobType']) }}</small>
                </td>
                <td>{{ row['cron'] }}</td>
                <td>{{ date(row['nextFireAt']) }}</td>
                <td>{{ status(row['lastResult']) }}</td>
                <td>
                  <label class="schedule-enabled">
                    <input type="checkbox" [checked]="row['enabled']"
                      [disabled]="scheduleUpdating().has(row['id'])"
                      [attr.aria-label]="row['name']+' 예약 활성화'"
                      (change)="toggleSchedule(row,$event)" />
                    <span>{{ scheduleUpdating().has(row['id']) ? '저장 중' : row['enabled'] ? '활성' : '비활성' }}</span>
                  </label>
                </td>
                <td>
                  <div class="row-actions">
                    <button
                      class="icon-button"
                      [disabled]="scheduleUpdating().has(row['id'])"
                      (click)="confirmAction('예약 수동 실행','저장된 대상과 구성으로 지금 실행합니다.','/schedules/'+row['id']+'/runs')"
                      aria-label="예약 수동 실행"
                    >
                      <wiz-icon name="play"></wiz-icon></button
                    ><button
                      class="icon-button"
                      [disabled]="scheduleUpdating().has(row['id'])"
                      (click)="historyRuns(row)"
                      aria-label="예약 실행 이력"
                    >
                      <wiz-icon name="history"></wiz-icon></button
                    ><button
                      class="icon-button"
                      [disabled]="scheduleUpdating().has(row['id'])"
                      (click)="openEdit(row)"
                      aria-label="예약 수정"
                    >
                      <wiz-icon name="edit"></wiz-icon></button
                    ><button
                      class="icon-button"
                      [disabled]="scheduleUpdating().has(row['id'])"
                      (click)="deleteRow(row)"
                      aria-label="예약 삭제"
                    >
                      <wiz-icon name="trash"></wiz-icon>
                    </button>
                  </div></td
              ></ng-container>
              <ng-container *ngSwitchCase="'operations'"
                ><td>
                  <a [routerLink]="'/operations/'+row['id']"
                    ><strong>{{ opLabel(row['type']) }}</strong
                    ><small class="operation-message-preview">{{ row['message'] || '진행 내용 없음' }}</small></a
                  >
                </td>
                <td>
                  {{ operationTargetLabel(row) }}<small
                    *ngIf="row['targetType'] && operationTargetLabel(row) !== row['targetType']"
                    >{{ row['targetType'] }}</small
                  >
                </td>
                <td>
                  <span class="badge" [ngClass]="tone(row['status'])"
                    ><i></i>{{ status(row['status']) }}</span
                  >
                </td>
                <td>{{ date(row['createdAt']) }}</td>
                <td>
                  <button
                    class="icon-button"
                    (click)="open(row)"
                    aria-label="작업 상세"
                  >
                    <wiz-icon name="chevron"></wiz-icon>
                  </button></td
              ></ng-container>
              <ng-container *ngSwitchCase="'reports'"
                ><td>
                  <button class="text-link" (click)="open(row)">
                    <wiz-icon name="calendar"></wiz-icon>{{
                    row['period']==='daily' ? '일간' : row['period']==='weekly'
                    ? '주간' : '월간' }} 운영 리포트</button
                  ><small>{{ row['summary'] }}</small>
                </td>
                <td>
                  {{ date(row['periodStart']) }} ~ {{ date(row['periodEnd']) }}
                </td>
                <td>
                  <span class="badge" [ngClass]="tone(row['status'])"
                    >{{ status(row['status']) }}</span
                  >
                </td>
                <td>{{ date(row['createdAt']) }}</td>
                <td>
                  <button
                    class="icon-button"
                    (click)="open(row)"
                    aria-label="리포트 열기"
                  >
                    <wiz-icon name="chevron"></wiz-icon>
                  </button></td
              ></ng-container>
              <ng-container *ngSwitchCase="'domains'"
                ><td>
                  <span class="badge info">{{ row['type'] }}</span
                  ><strong style="margin-left: 8px">{{ row['name'] }}</strong
                  >
                </td>
                <td class="record-value" [title]="row['content']">
                  {{ row['content'] }}
                </td>
                <td>{{ row['ttl']===1 ? '자동' : row['ttl'] }}</td>
                <td>
                  <div class="row-actions">
                    <button
                      class="icon-button"
                      [disabled]="busy()"
                      (click)="openRecord(row)"
                      aria-label="레코드 수정"
                    >
                      <wiz-icon name="edit"></wiz-icon></button
                    ><button
                      class="icon-button"
                      [disabled]="busy()"
                      (click)="deleteDnsRecord(row)"
                      aria-label="레코드 삭제"
                    >
                      <wiz-icon name="trash"></wiz-icon>
                    </button>
                  </div></td
              ></ng-container>
              <ng-container *ngSwitchCase="'images'"
                ><td>
                  <input
                    type="checkbox"
                    class="row-checkbox"
                    [checked]="imageSelected(row)"
                    [disabled]="imageWorking || !imageDigests(row).length"
                    (change)="selectImage(row)"
                    aria-label="삭제할 이미지 버전 선택"
                  />
                </td>
                <td>
                  <strong>{{ imageRef(row) }}</strong>
                </td>
                <td>
                  <div class="version-badges">
                    <span
                      class="badge"
                      *ngFor="let version of row['versions']"
                      [ngClass]="version['used'] ? 'success' : version['protected'] ? 'info' : 'neutral'"
                      >{{ version['label'] }}</span
                    >
                  </div>
                </td>
                <td>{{ bytes(row['size']) }}</td>
                <td>
                  {{ date(row['created']) }}<small
                    >최근 사용 {{ date(row['lastUsed']) }}</small
                  >
                </td>
                <td>
                  <span
                    class="badge"
                    [ngClass]="imageUsed(row) ? 'success' : row['protected'] ? 'info' : 'neutral'"
                    >{{ imageUsed(row) ? '사용 중' : row['protected'] ? '보호됨'
                    : '미사용' }}</span
                  >
                </td>
                <td>
                  <button
                    class="icon-button"
                    [disabled]="imageWorking || !imageDigests(row).length"
                    (click)="imageDelete(row)"
                    aria-label="이미지 버전 삭제 검토"
                  >
                    <wiz-icon name="trash"></wiz-icon>
                  </button></td
              ></ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-state" *ngIf="!displayed.length && !loading()">
        <span class="empty-icon"
          ><wiz-icon [name]="search || filter || operationType || operationServer ? 'search' : icon"></wiz-icon
        ></span>
        <h3>
          {{ section==='reports' && (reportPeriod || reportFrom || reportTo) ? '조건에 맞는 리포트가 없습니다' : section==='operations' && (filter || operationType || operationServer) ? '조건에 맞는 작업이 없습니다' : search || filter ? '검색 결과가 없습니다' : section==='images' &&
          !selectedServer ? '조회할 서버를 선택해 주세요' : section==='domains'
          && !selectedZone ? 'Cloudflare Zone을 연결하고 선택해 주세요' :
          section==='operations' ? '아직 실행한 작업이 없습니다' :
          section==='reports' ? '아직 생성된 리포트가 없습니다' : '아직 등록된 '
          + title + ' 항목이 없습니다' }}
        </h3>
        <p>
          {{ section==='reports' && (reportPeriod || reportFrom || reportTo) ? '리포트 주기나 분석 기간을 변경해 다시 확인해 보세요.' : section==='operations' && (filter || operationType || operationServer) ? '작업 종류·상태·대상 서버를 전체로 바꾸어 다시 확인해 보세요.' : search || filter ? '다른 검색어나 상태 필터로 다시 확인해 보세요.'
          : section==='services' ? '템플릿과 실행 서버를 선택해 첫 번째 서비스를
          배포하세요.' : section==='servers' ? '서버를 연결하면 자원 사용량과
          배포 준비 상태를 확인할 수 있습니다.' : section==='templates' ?
          '사용할 이미지와 입력값을 정의해 나만의 서비스 구성을 만드세요.' :
          section==='images' ? '연결한 서버의 이미지, 용량, 사용 상태가 여기에
          표시됩니다.' : section==='domains' ? 'Cloudflare API 토큰을 등록해
          일반 DNS 레코드를 관리하세요.' : section==='operations' ? '서버 점검,
          서비스 배포와 예약 작업 결과가 여기에 쌓입니다.' : section==='reports'
          ? '완료된 기간의 자원과 서비스 상태를 분석해 운영 인사이트를
          확인하세요.' : '새로운 항목을 추가해 워크스페이스를 구성하세요.' }}
        </p>
        <button
          class="button"
          *ngIf="canCreate && !search && !filter"
          (click)="openCreate()"
        >
          <wiz-icon name="plus"></wiz-icon>{{ createLabel }}</button
        ><a
          class="text-link"
          routerLink="/servers"
          *ngIf="section==='images' && !servers().length"
          >서버 연결하기<wiz-icon name="arrow"></wiz-icon
        ></a>
      </div>
      <div class="table-footer">
        <span
          >{{ filtered.length }}개 항목 · 최대 {{ pageSize }}개씩 표시<span
            *ngIf="total > rows().length"
          >
            · 전체 {{ total }}개</span
          ></span
        >
        <nav class="pagination" aria-label="목록 페이지 이동">
          <button type="button" class="icon-button" (click)="goToPage(1)" [disabled]="loading() || page===1" aria-label="처음 페이지"><wiz-icon name="chevrons-left"></wiz-icon></button>
          <button type="button" class="icon-button" (click)="goToPage(page-1)" [disabled]="loading() || page===1" aria-label="이전 페이지"><wiz-icon name="chevron-left"></wiz-icon></button>
          <ng-container *ngFor="let number of pageNumbers">
            <button *ngIf="number; else pageGap" type="button" class="page-number"
              [class.active]="page===number" [attr.aria-current]="page===number ? 'page' : null"
              [attr.aria-label]="number + '페이지'" [disabled]="loading()" (click)="goToPage(number)">{{ number }}</button>
            <ng-template #pageGap><span class="page-gap" aria-hidden="true">…</span></ng-template>
          </ng-container>
          <button type="button" class="icon-button" (click)="goToPage(page+1)" [disabled]="loading() || page>=pages" aria-label="다음 페이지"><wiz-icon name="chevron"></wiz-icon></button>
          <button type="button" class="icon-button" (click)="goToPage(pages)" [disabled]="loading() || page>=pages" aria-label="마지막 페이지"><wiz-icon name="chevrons-right"></wiz-icon></button>
        </nav>
      </div>
    </section>
    <wiz-apache-host #apacheHost
      *ngIf="section==='domains' && tab==='apache-host'"
    ></wiz-apache-host>
  </ng-container>
  <ng-container *ngIf="id && detail() as d"
    ><div class="detail-navigation" *ngIf="section!=='operations'">
      <div class="tabs detail-tabs">
      <button *ngIf="section!=='templates'" [class.active]="tab==='overview'" (click)="selectTab('overview')">
        <wiz-icon name="help"></wiz-icon>기본 정보</button
      ><ng-container *ngIf="section==='services'"
        ><button
          [class.active]="tab==='compose'"
          (click)="selectTab('compose')"
        >
          <wiz-icon name="layout"></wiz-icon>Compose</button
        ><button
          [class.active]="tab==='runtime'"
          (click)="selectTab('runtime')"
        >
          <wiz-icon name="chevron"></wiz-icon>런타임</button
        ><button
          [class.active]="tab==='environment'"
          (click)="selectTab('environment')"
        >
          <wiz-icon name="chevron"></wiz-icon>환경변수</button
        ><button [class.active]="tab==='service-health'" (click)="selectTab('service-health')"><wiz-icon name="activity"></wiz-icon>HTTP · TCP 상태 점검</button
        ><button
          [class.active]="tab==='versions'"
          (click)="selectTab('versions')"
        >
          <wiz-icon name="history"></wiz-icon>구성 이력</button
        ><button [class.active]="tab==='apache'" (click)="selectTab('apache')">
          <wiz-icon name="settings"></wiz-icon>프록시 설정</button></ng-container
      ><ng-container *ngIf="section==='servers'"
        ><button [class.active]="tab==='containers'" (click)="selectTab('containers')"><wiz-icon name="cube"></wiz-icon>컨테이너</button
        ><button
          [class.active]="tab==='metrics'"
          (click)="selectTab('metrics')"
        >
          <wiz-icon name="history"></wiz-icon>자원 이력</button
        ><button
          [class.active]="tab==='ai-audit'"
          (click)="selectTab('ai-audit')"
        >
          <wiz-icon name="spark"></wiz-icon>AI 종합 점검
        </button></ng-container
      ><ng-container *ngIf="section==='templates'">
        <button *ngFor="let item of templateSections" [class.active]="tab===item.id" [attr.aria-pressed]="tab===item.id" (click)="selectTab(item.id)"><wiz-icon [name]="item.icon"></wiz-icon>{{ item.label }}</button>
      </ng-container
      ><button
        *ngIf="section==='macros'"
        [class.active]="tab==='compose'"
        (click)="selectTab('compose')"
      >
        <wiz-icon name="terminal"></wiz-icon>스크립트</button
      ><button
        *ngIf="section==='servers' || section==='services'"
        [class.active]="tab==='files'"
        (click)="selectTab('files')"
      >
        <wiz-icon name="file"></wiz-icon>파일 탐색</button
      ><button
        *ngIf="section==='servers'"
        [class.active]="tab==='terminal'"
        (click)="selectTab('terminal')"
      >
        <wiz-icon name="terminal"></wiz-icon>터미널</button
      ><button
        *ngIf="section==='macros'"
        [class.active]="tab==='files'"
        (click)="selectTab('files')"
      >
        <wiz-icon name="file"></wiz-icon>첨부 파일</button>
      </div>
      <div class="detail-actions" aria-label="상세 화면 작업">
        <ng-container *ngIf="section==='templates'">
          <button class="button small" (click)="openEdit(d)" aria-label="템플릿 수정" title="템플릿 수정"><wiz-icon name="edit"></wiz-icon><span>템플릿 수정</span></button>
          <a class="button small primary" routerLink="/services" [queryParams]="{create:true,templateId:d['id']}" aria-label="서비스 만들기" title="서비스 만들기"><wiz-icon name="plus"></wiz-icon><span>서비스 만들기</span></a>
          <button class="button small" (click)="cloneTemplate()" aria-label="템플릿 복제" title="템플릿 복제"><wiz-icon name="copy"></wiz-icon><span>템플릿 복제</span></button>
          <button class="button small danger" (click)="deleteRow(d)" aria-label="템플릿 삭제" title="템플릿 삭제"><wiz-icon name="trash"></wiz-icon><span>템플릿 삭제</span></button>
          <span class="template-action-divider" aria-hidden="true"></span>
        </ng-container>
        <ng-container *ngIf="section==='servers'">
          <button class="button small" *ngIf="d['executionMode']!=='local'" [disabled]="busy() || !!operation() || !d['credentialConfigured'] || !d['fingerprint']" (click)="setupServer(d)" [attr.aria-label]="serverSetupOperation()?.['status']==='failed' || serverSetupOperation()?.['status']==='canceled' ? '자동 구성 재시도' : '자동 구성 다시 실행'" title="자동 구성 다시 실행"><wiz-icon name="settings"></wiz-icon><span>{{ serverSetupOperation()?.['status']==='failed' || serverSetupOperation()?.['status']==='canceled' ? '자동 구성 재시도' : '자동 구성 다시 실행' }}</span></button>
          <button class="button small primary" [disabled]="busy() || !!operation()" (click)="serverCheck(d)" aria-label="연결 점검" title="연결 점검"><wiz-icon name="check"></wiz-icon><span>연결 점검</span></button>
          <button class="button small danger" *ngIf="!d['isControlHost'] && d['executionMode']!=='local'" [disabled]="busy() || !!operation() || d['status']==='disconnecting'" (click)="deleteRow(d)" [attr.aria-label]="d['status']==='disconnect-failed' ? '연결 해제 재시도' : '서버 연결 해제'" title="서버 연결 해제"><wiz-icon name="trash"></wiz-icon><span>{{ d['status']==='disconnect-failed' ? '연결 해제 재시도' : '서버 연결 해제' }}</span></button>
        </ng-container>
        <button
          class="button small"
          *ngIf="section==='servers'"
          aria-label="서버 설정 수정"
          title="서버 설정 수정"
          (click)="openEdit(d)"
        >
          <wiz-icon name="edit"></wiz-icon><span>서버 설정 수정</span>
        </button>
        <a
          class="button small"
          [routerLink]="'/' + section"
          aria-label="목록으로"
          title="목록으로"
        >
          <wiz-icon name="back"></wiz-icon><span>목록으로</span>
        </a>
      </div>
    </div>
    <ng-container *ngIf="tab==='overview' && section!=='templates'"
      ><div class="detail-grid" [class.single]="section==='servers'" [class.operation-detail-grid]="section==='operations'">
        <section class="panel">
          <div class="panel-header">
            <h2>{{ section==='operations' ? '작업 정보' : '기본 정보' }}</h2>
            <div class="panel-header-actions">
              <button class="button small" *ngIf="section==='servers'" (click)="openServerConfiguration()"><wiz-icon name="settings"></wiz-icon>연결 및 서버 구성</button>
              <span
                class="badge"
                [ngClass]="tone(d['status'])"
                *ngIf="d['status']"
                >{{ status(d['status']) }}</span
              ><a
                class="button small"
                *ngIf="section==='operations'"
                [routerLink]="'/' + section"
                ><wiz-icon name="back"></wiz-icon>목록으로</a
              >
            </div>
          </div>
          <div class="panel-body">
            <ng-container *ngIf="section==='servers'">
            <ng-container *ngIf="serverSetupOperation() as setup"><div class="server-setup-progress" role="status" aria-live="polite" *ngIf="setup['status']!=='succeeded'">
              <span class="badge" [ngClass]="tone(setup['status'])">{{ status(setup['status']) }}</span>
              <p>{{ setup['message'] }}</p>
              <a [routerLink]="'/operations/'+setup['id']">자동 구성 작업 기록</a>
            </div></ng-container>
            <div class="server-setup-progress server-disconnect-progress" role="status" aria-live="polite" *ngIf="serverDisconnectOperation() as disconnect">
              <span class="badge" [ngClass]="tone(disconnect['status'])">연결 해제 · {{ status(disconnect['status']) }}</span>
              <p>{{ disconnect['message'] }}</p>
              <a [routerLink]="'/operations/'+disconnect['id']">연결 해제 작업 기록</a>
            </div>
            </ng-container>
            <dl class="definition-list">
              <div>
                <dt>이름 / 종류</dt>
                <dd>{{ d['name'] || opLabel(d['type']) }}</dd>
              </div>
              <div *ngIf="section!=='services'">
                <dt>식별자</dt>
                <dd>{{ d['id'] }}</dd>
              </div>
              <div *ngIf="d['description']">
                <dt>설명</dt>
                <dd>{{ d['description'] }}</dd>
              </div>
              <ng-container *ngIf="section==='services'"
                ><div>
                  <dt>실행 서버</dt>
                  <dd><a *ngIf="d['serverId']; else noServiceServer" class="text-link service-info-link" [routerLink]="'/servers/'+d['serverId']" target="_blank" rel="noopener noreferrer"><wiz-icon name="server"></wiz-icon>{{ d['serverName'] || serverName(d['serverId']) }}<wiz-icon name="external"></wiz-icon></a><ng-template #noServiceServer>미선택</ng-template></dd>
                </div>
                <div>
                  <dt>서비스 도메인</dt>
                  <dd><a *ngIf="d['domain']; else noServiceDomain" class="text-link service-info-link" [href]="'https://'+d['domain']" target="_blank" rel="noopener noreferrer"><wiz-icon name="globe"></wiz-icon>{{ d['domain'] }}<wiz-icon name="external"></wiz-icon></a><ng-template #noServiceDomain>연결 안 됨</ng-template></dd>
                </div>
                <div>
                  <dt>Compose 버전</dt>
                  <dd>{{ d['composeVersion'] }}</dd>
                </div></ng-container
              ><ng-container *ngIf="section==='servers'"
                ><div>
                  <dt>접속 주소</dt>
                  <dd>
                    {{ d['executionMode']==='local' ? '현재 호스트 · 로컬 명령
                    실행' : d['username']+'@'+d['host']+':'+d['port'] }}
                  </dd>
                </div>
                <div>
                  <dt>관리 콘솔 호스트</dt>
                  <dd>{{ d['isControlHost'] ? '예' : '아니요' }}</dd>
                </div>
                <div>
                  <dt>배포 점수</dt>
                  <dd>
                    {{ d['score'] ?? '집계 대기' }} · {{ d['eligible'] ? '배포 가능' :
                    '준비 필요' }}
                    <ng-container *ngTemplateOutlet="deploymentWindows; context: {$implicit:d, compact:true}"></ng-container>
                  </dd>
                </div>
                <div>
                  <dt>최근 수집</dt>
                  <dd>{{ date(d['metricAt']) }}</dd>
                </div></ng-container
              ><ng-container *ngIf="section==='operations'"
                ><div>
                  <dt>작업 대상</dt>
                  <dd>{{ d['targetLabel'] || d['targetType']+' · '+d['targetId'] }}</dd>
                </div></ng-container
              >

              <div>
                <dt>생성 시각</dt>
                <dd>{{ date(d['createdAt']) }}</dd>
              </div>
              <div *ngIf="d['updatedAt']">
                <dt>최근 변경</dt>
                <dd>{{ date(d['updatedAt']) }}</dd>
              </div>
            </dl>
            <div class="operation-request-details" *ngIf="section==='operations' && d['details']?.length">
              <h3>접수 당시 요청 내용</h3>
              <dl class="definition-list" tabindex="0" aria-label="접수 당시 요청 내용">
                <div *ngFor="let field of d['details']"><dt>{{ field.label }}</dt><dd>{{ field.value }}</dd></div>
              </dl>
            </div>
            <div class="notice warn" style="margin-top:18px" *ngIf="section==='servers' && d['exclusionReasons']?.length"><wiz-icon name="help"></wiz-icon><div><strong>배포 전 확인이 필요합니다</strong><p *ngFor="let reason of d['exclusionReasons']">{{ reason }}</p></div></div>
          </div>
        </section>
        <aside>
          <section class="panel operation-logs" *ngIf="section==='operations'">
            <div class="panel-header">
              <h2 id="operation-logs-title">실행 로그</h2>
              <button
                  class="button small danger"
                  *ngIf="d['status']==='queued' || (d['type']?.startsWith('deployment-') && ['preparing','running','verifying'].includes(d['status']))"
                  [disabled]="busy()"
                  (click)="confirmAction('작업 취소', '선택한 작업을 취소합니다. 이미 적용한 변경은 실행 상태에 따라 유지될 수 있습니다.', '/operations/'+id+'/cancel')"
                >
                  <wiz-icon name="stop"></wiz-icon>작업 취소
                </button>
            </div>
            <div class="panel-body">
              <p class="muted operation-log-note">진행 중인 작업의 상태와 로그는 자동으로 갱신됩니다.</p>
              <ol class="operation-events" *ngIf="d['events']?.length" tabindex="0" aria-labelledby="operation-logs-title">
                <li class="operation-event" *ngFor="let event of d['events']" [class.error]="event.level==='error'" [class.warning]="event.level==='warn' || event.level==='warning'">
                  <div class="operation-event-meta">
                    <time>{{ date(event.createdAt || event.timestamp) }}</time>
                    <span>{{ event.level || event.phase || '기록' }}</span>
                  </div>
                  <pre class="operation-event-message">{{ event.message || event.output || event.text }}</pre>
                </li>
              </ol>
              <button type="button" class="button small" *ngIf="operationEventsRemaining" [disabled]="operationEventsLoading()" (click)="loadMoreOperationEvents()">{{ operationEventsLoading() ? '불러오는 중…' : '실행 로그 더 보기' }}</button>
              <div class="empty-state compact" *ngIf="!d['events']?.length">
                <h3>아직 기록된 출력이 없습니다</h3>
                <p>작업이 시작되면 단계별 출력이 여기에 표시됩니다.</p>
              </div>
            </div>
          </section>
          <section class="panel" *ngIf="section!=='servers' && section!=='operations'">
            <div class="panel-header">
              <h2>작업</h2>
              <wiz-icon name="activity"></wiz-icon>
            </div>
            <div class="panel-body">
              <div class="check-list" *ngIf="section==='services'">
                <button
                  class="button"
                  *ngIf="canServiceAction('preflight')"
                  (click)="checkService()"
                  [disabled]="busy()"
                >
                  <wiz-icon name="shield"></wiz-icon>배포 사전 점검</button
                ><button
                  class="button primary"
                  *ngIf="canServiceAction('deploy')"
                  (click)="serviceAction('deploy')"
                  [disabled]="!d['serverId'] || busy()"
                >
                  <wiz-icon name="play"></wiz-icon>선택 서버에 배포
                </button>
                <div class="two-columns" *ngIf="canServiceAction('restart') || canServiceAction('stop') || canServiceAction('start')">
                  <button class="button primary" *ngIf="canServiceAction('start')" (click)="serviceAction('start')" [disabled]="busy()"><wiz-icon name="play"></wiz-icon>서비스 시작</button>
                  <button
                    class="button"
                    *ngIf="canServiceAction('restart')"
                    (click)="serviceAction('restart')"
                    [disabled]="!d['serverId'] || busy()"
                  >
                    <wiz-icon name="refresh"></wiz-icon>재시작</button
                  ><button
                    class="button"
                    *ngIf="canServiceAction('stop')"
                    (click)="serviceAction('stop')"
                    [disabled]="!d['serverId'] || busy()"
                  >
                    <wiz-icon name="stop"></wiz-icon>중지
                  </button>
                </div>
                <button class="button" *ngIf="canServiceAction('edit')" [disabled]="busy()" (click)="openEdit(d)">
                  <wiz-icon name="edit"></wiz-icon>서비스 구성 수정</button
                ><button class="button" *ngIf="canServiceAction('domain')" [disabled]="busy()" (click)="linkServiceDomain()">
                  <wiz-icon name="globe"></wiz-icon>서비스 도메인 연결</button
                ><button class="button" *ngIf="canServiceAction('migrate')" [disabled]="busy()" (click)="migrateService()">
                  <wiz-icon name="arrow"></wiz-icon>다른 서버로 이동</button
                ><button
                  class="button danger"
                  *ngIf="canServiceAction('remove')"
                  [disabled]="busy()"
                  (click)="serviceAction('remove')"
                >
                  <wiz-icon name="trash"></wiz-icon>서비스 제거
                </button>
                <button class="button danger" *ngIf="canServiceAction('delete-draft')" [disabled]="busy()" (click)="deleteRow(d)"><wiz-icon name="trash"></wiz-icon>서비스 초안 삭제</button>
                <p class="small-note" *ngIf="!availableServiceActions().size">진행 중인 작업이 끝나면 서비스 작업을 사용할 수 있습니다.</p>
              </div>
              <div class="check-list" *ngIf="section==='macros'">
                <button
                  class="button primary"
                  (click)="openMacroRun(d)"
                >
                  <wiz-icon name="play"></wiz-icon>매크로 실행</button
                ><button class="button" (click)="openEdit(d)">
                  <wiz-icon name="edit"></wiz-icon>매크로 수정</button
                ><button class="button" (click)="historyRuns()">
                  <wiz-icon name="history"></wiz-icon>실행 이력</button
                ><button class="button danger" (click)="deleteRow(d)">
                  <wiz-icon name="trash"></wiz-icon>매크로 삭제
                </button>
              </div>

            </div>
          </section>
          <div
            class="notice warn"
            style="margin-top: 18px"
            *ngIf="section==='servers' && d['exclusionReasons']?.length"
          >
            <wiz-icon name="help"></wiz-icon>
            <div>
              <strong>배포 전 확인이 필요합니다</strong>
              <p *ngFor="let reason of d['exclusionReasons']">{{ reason }}</p>
            </div>
          </div>
        </aside>
      </div></ng-container
    >
    <ng-container *ngIf="section==='templates'">
      <section class="panel template-section" *ngIf="tab==='overview'">
        <div class="panel-header"><h2>기본 정보</h2><span class="badge" [ngClass]="d['enabled'] ? 'success' : 'neutral'">{{ d['enabled'] ? '사용 가능' : '비활성' }}</span></div>
        <div class="panel-body">
          <p class="template-description">{{ d['description'] || '등록된 설명이 없습니다.' }}</p>
          <dl class="definition-list">
            <div><dt>이름</dt><dd>{{ d['name'] }}</dd></div>
            <div><dt>템플릿 ID</dt><dd>{{ d['id'] }}</dd></div>
            <div><dt>분류</dt><dd>{{ d['tags']?.join(', ') || '없음' }}</dd></div>
            <div><dt>생성 시각</dt><dd>{{ date(d['createdAt']) }}</dd></div>
          </dl>
        </div>
      </section>
      <section class="panel template-section template-usage-section" *ngIf="tab==='overview'">
        <div class="panel-header"><h2>사용 안내</h2><span class="muted">서비스 생성 화면에도 표시됩니다</span></div>
        <div class="panel-body">
          <ul class="template-instructions template-detail-instructions" *ngIf="d['instructions']?.length"><li *ngFor="let note of d['instructions']">{{ note }}</li></ul>
          <p class="muted" *ngIf="!d['instructions']?.length">등록된 사용 안내가 없습니다.</p>
        </div>
      </section>
      <section class="panel template-section" *ngIf="tab==='template-inputs'">
        <div class="panel-header"><h2>입력 설정</h2><span class="muted">{{ d['inputs']?.length || 0 }}개</span></div>
        <div class="panel-body">
          <p class="small-note">서비스를 만들 때 입력받을 값과 검증 조건입니다.</p>
          <p class="muted" *ngIf="!d['inputs']?.length">추가 입력값이 없습니다.</p>
          <div class="template-input-cards">
            <article class="template-input-card" *ngFor="let input of d['inputs']">
              <header><div><h3>{{ input.label || input.key }}</h3><code>{{ input.key }}</code></div><span class="badge neutral">{{ input.type || 'string' }}</span></header>
              <p *ngIf="input.description">{{ input.description }}</p>
              <dl><div *ngFor="let fact of templateInputFacts(input)"><dt>{{ fact.label }}</dt><dd>{{ fact.value }}</dd></div></dl>
            </article>
          </div>
        </div>
      </section>
    </ng-container>
    <section class="panel" [class.template-source-panel]="section==='templates' || section==='services'" *ngIf="tab==='compose'">
      <div class="panel-header">
        <h2>
          {{ section==='templates' ? 'docker-compose.yaml' : section==='macros' ? 'Shell
          스크립트' : 'Compose 구성' }}
        </h2>
        <div class="panel-header-actions">
        <ng-container *ngIf="section==='services'">
          <button class="button small" *ngIf="canServiceAction('compose')" [disabled]="busy()" (click)="editServiceCompose()"><wiz-icon name="edit"></wiz-icon>Compose 편집</button>
          <button class="button small primary" *ngIf="canServiceAction('apply-compose')" [disabled]="busy()" (click)="serviceAction('deploy')"><wiz-icon name="play"></wiz-icon>저장한 구성 배포</button>
        </ng-container>
        <button
          class="button small"
          [disabled]="section==='services' && (serviceComposeLoading() || !!serviceComposeError())" (click)="copy(section==='services' ? serviceCompose() : d['compose'] || d['script'])"
        >
          <wiz-icon name="copy"></wiz-icon>복사
        </button>
        </div>
      </div>
      <details class="template-compose-summary" *ngIf="section==='templates'">
        <summary>실행 구성 · {{ templateSummary().components.length }}개 컨테이너<span *ngIf="d['publicEndpoint']?.service"> · 기본 연결 {{ d['publicEndpoint'].service }}:{{ d['publicEndpoint'].port }}</span></summary>
        <div class="template-compose-summary-body">
          <article class="template-component" *ngFor="let component of templateSummary().components"><h4>{{ component.name }}</h4><dl class="definition-list"><div><dt>이미지</dt><dd>{{ component.image }}</dd></div><div *ngFor="let field of component.fields"><dt>{{ field.label }}</dt><dd>{{ field.value }}</dd></div></dl></article>
          <dl class="definition-list"><div><dt>데이터 볼륨</dt><dd>{{ templateSummary().volumes.join(', ') || '없음' }}</dd></div><div><dt>네트워크</dt><dd>{{ templateSummary().networks.join(', ') }}</dd></div></dl>
        </div>
      </details>
      <wiz-code-editor *ngIf="section==='templates'" language="yaml" label="docker-compose.yaml 읽기 전용" [ngModel]="d['compose'] || ''" [readonly]="true" [fill]="true"></wiz-code-editor>
      <div class="loading-state" *ngIf="section==='services' && serviceComposeLoading()" role="status"><span class="spinner"></span>Compose 구성을 불러오고 있습니다.</div>
      <div class="notice error" *ngIf="section==='services' && serviceComposeError()" role="alert">{{ serviceComposeError() }}<button class="button small" (click)="loadServiceCompose()">다시 불러오기</button></div>
      <wiz-code-editor *ngIf="section==='services' && !serviceComposeLoading() && !serviceComposeError()" language="yaml" label="Compose 구성 원문" [ngModel]="serviceCompose()" [readonly]="true" [fill]="true"></wiz-code-editor>
      <pre class="code-block" *ngIf="section==='macros'">
{{ d['compose'] || d['script'] || '저장된 구성이 없습니다.' }}</pre
      >
    </section>
    <section class="panel template-source-panel" *ngIf="section==='templates' && tab==='template-apache'">
      <div class="panel-header"><h2>Apache2</h2><button class="button small" (click)="copy(d['apache'])"><wiz-icon name="copy"></wiz-icon>복사</button></div>
      <p class="template-code-note">새 서비스의 도메인 연결에 사용할 HTTP VirtualHost입니다. 도메인·대상 호스트·포트와 HTTPS는 서비스 연결 시 자동 구성합니다.</p>
      <wiz-code-editor [ngModel]="d['apache']" [readonly]="true" [fill]="true" language="apache" label="Apache2 읽기 전용"></wiz-code-editor>
    </section>
    <section class="panel" *ngIf="tab==='runtime'">
      <div class="panel-header">
        <h2>실행 컨테이너</h2>
        <button class="button small" (click)="selectTab('runtime')">
          <wiz-icon name="refresh"></wiz-icon>상태 확인
        </button>
      </div>
      <p class="runtime-status-guide small-note">실행 상태는 Docker 컨테이너의 동작 상태이며, Health는 컨테이너의 healthcheck 결과입니다. 점검 미설정은 healthcheck가 없는 상태입니다.</p>
      <div
        class="empty-state"
        *ngIf="!d['runtime']?.length && !d['runtime']?.containers?.length"
      >
        <span class="empty-icon"><wiz-icon name="cube"></wiz-icon></span>
        <h3>확인된 컨테이너가 없습니다</h3>
        <p>서비스 배포와 실행 환경 점검 후 런타임 상태를 확인할 수 있습니다.</p>
      </div>
      <div class="table-wrap" *ngIf="d['runtime']?.length">
        <table class="service-runtime-table">
          <thead>
            <tr>
              <th>구성요소</th>
              <th>상태 · Health</th>
              <th>이미지</th>
              <th class="runtime-actions">작업</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of d['runtime']">
              <td>
                <strong>{{ componentName(c) }}</strong
                ><div class="runtime-identifier"><code [title]="containerId(c)">{{ shortContainerId(c) }}</code><button type="button" class="icon-button compact" *ngIf="containerId(c)" (click)="copy(containerId(c))" [attr.aria-label]="componentName(c)+' 컨테이너 ID 복사'" title="전체 컨테이너 ID 복사"><wiz-icon name="copy"></wiz-icon></button></div>
              </td>
              <td>
                <div class="runtime-statuses"><span class="badge" [ngClass]="(c.state || c.State)==='running' ? 'success' : tone(c.state || c.State)" title="Docker 컨테이너 실행 상태">{{ runtimeState(c) }}</span><span class="badge" [ngClass]="(c.health || c.Health)==='starting' ? 'info' : tone(c.health || c.Health)" title="Docker healthcheck 결과">{{ runtimeHealth(c) }}</span></div>
              </td>
              <td class="record-value" [title]="runtimeImage(c)">
                <strong>{{ runtimeImage(c) }}</strong>
              </td>
              <td class="runtime-actions">
                <div class="row-actions">
                  <button
                    class="icon-button"
                    (click)="containerAction('start',c)"
                    aria-label="구성요소 시작"
                  >
                    <wiz-icon name="play"></wiz-icon></button
                  ><button
                    class="icon-button"
                    (click)="containerAction('restart',c)"
                    aria-label="구성요소 재시작"
                  >
                    <wiz-icon name="refresh"></wiz-icon></button
                  ><button
                    class="icon-button"
                    (click)="containerAction('stop',c)"
                    aria-label="구성요소 중지"
                  >
                    <wiz-icon name="stop"></wiz-icon></button
                  ><button
                    class="icon-button"
                    (click)="showLogs(c)"
                    aria-label="구성요소 로그"
                  >
                    <wiz-icon name="file"></wiz-icon></button
                  ><button
                    class="icon-button"
                    (click)="showTerminal(c)"
                    aria-label="구성요소 터미널"
                  >
                    <wiz-icon name="terminal"></wiz-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="panel" *ngIf="tab==='versions'">
      <div class="panel-header"><h2>Compose 구성 이력</h2><span class="count-label">{{ extra().length }}개 버전</span></div>
      <div class="table-wrap" *ngIf="extra().length"><table>
        <thead><tr><th>버전</th><th>저장 시각</th><th>작업</th></tr></thead>
        <tbody><tr *ngFor="let version of extra()">
          <td>v{{ version['version'] }}</td><td>{{ date(version['createdAt']) }}</td>
          <td><div class="row-actions">
            <button class="button small" (click)="showVersion(version)"><wiz-icon name="file"></wiz-icon>Compose 보기 · 복사</button>
            <button class="button small" (click)="showVersion(version,true)"><wiz-icon name="history"></wiz-icon>변경 비교</button>
          </div></td>
        </tr></tbody>
      </table></div>
      <div class="empty-state" *ngIf="!extra().length"><h3>저장된 구성 이력이 없습니다</h3><p>Compose를 수정하고 저장하면 변경 이력이 기록됩니다.</p></div>
    </section>
    <section class="panel" *ngIf="tab==='metrics'">
      <div class="panel-header">
        <h2>서버 자원 이력</h2>
        <div class="resource-periods" role="group" aria-label="자원 이력 조회 기간">
          <button *ngFor="let period of resourcePeriods" class="button small" [class.primary]="resourcePeriod===period.hours" [attr.aria-pressed]="resourcePeriod===period.hours" [disabled]="resourcesLoading()" (click)="setResourcePeriod(period.hours)"><wiz-icon name="history"></wiz-icon>{{ period.label }}</button>
        </div>
        <div class="toolbar-right">
          <input
            class="filter-select"
            type="date"
            [(ngModel)]="dateFrom"
            (ngModelChange)="resourcePeriod=0"
            aria-label="조회 시작일"
          /><input
            class="filter-select"
            type="date"
            [(ngModel)]="dateTo"
            (ngModelChange)="resourcePeriod=0"
            aria-label="조회 종료일"
          /><button class="button small" [disabled]="resourcesLoading()" (click)="loadResources()">
            <wiz-icon name="search"></wiz-icon>조회하기</button
          ><button class="button small" [disabled]="resourcesLoading() || busy()" (click)="statistics()">
            <wiz-icon name="activity"></wiz-icon>자원 통계 보기</button
          ><button class="button small" [disabled]="resourcesLoading() || busy()" (click)="deleteMetrics()">
            <wiz-icon name="trash"></wiz-icon>조회 기간 지표 삭제
          </button>
        </div>
      </div>
      <div class="resource-history-charts" *ngIf="resources().length">
        <section class="resource-history-chart">
          <h3>CPU <small>평균 · 최소/최대</small></h3>
          <wiz-resource-chart
            [points]="resources()"
            [rangeStart]="resourceWindow()?.from || ''"
            [rangeEnd]="resourceWindow()?.to || ''"
            metric="cpuPercent"
            [showRange]="true"
            [bucketSeconds]="3600"
            label="서버 CPU 추이"
          ></wiz-resource-chart>
        </section>
        <section class="resource-history-chart">
          <h3>메모리 <small>평균 · 최소/최대</small></h3>
          <wiz-resource-chart
            [points]="resources()"
            [rangeStart]="resourceWindow()?.from || ''"
            [rangeEnd]="resourceWindow()?.to || ''"
            metric="memoryPercent"
            [showRange]="true"
            [bucketSeconds]="3600"
            label="서버 메모리 추이"
          ></wiz-resource-chart>
        </section>
        <section class="resource-history-chart">
          <h3>스토리지 <small>평균</small></h3>
          <wiz-resource-chart
            [points]="resources()"
            [rangeStart]="resourceWindow()?.from || ''"
            [rangeEnd]="resourceWindow()?.to || ''"
            metric="storagePercent"
            [bucketSeconds]="3600"
            label="서버 스토리지 추이"
          ></wiz-resource-chart>
        </section>
      </div>
      <div class="loading-state" *ngIf="resourcesLoading()"><span class="spinner"></span>자원 이력을 조회하고 있습니다.</div>
      <div class="empty-state" *ngIf="!resourcesLoading() && !resources().length">
        <span class="empty-icon"><wiz-icon name="chart"></wiz-icon></span>
        <h3>조회 기간에 수집한 지표가 없습니다</h3>
        <p>서버 Agent의 수집 상태를 확인하거나 조회 기간을 변경하세요.</p>
      </div>
    </section>
    <section class="panel" *ngIf="tab==='ai-audit'">
      <div class="panel-header">
        <div>
          <h2>AI 서버 종합 점검</h2>
          <p>
            읽기 전용 수집 후 보안·스토리지·프로세스·패키지·Docker 상태를
            분석합니다.
          </p>
        </div>
        <button
          class="button primary"
          (click)="startAudit()"
          [disabled]="busy() || ['analyzing','optimizing'].includes(serverAudit()?.['status'])"
        >
          <wiz-icon name="spark"></wiz-icon>{{ serverAudit() ? '다시 분석' :
          '분석 시작' }}
        </button>
      </div>
      <div class="panel-body">
        <div class="notice">
          <wiz-icon name="shield"></wiz-icon>
          <div>
            <strong>2단계 승인 방식</strong>
            <p>
              1단계 분석은 서버를 변경하지 않습니다. 2단계에서 아래 권고 중 직접
              선택한 안전 작업만 별도 실행합니다.
            </p>
          </div>
        </div>
        <div
          class="loading-state"
          *ngIf="serverAudit()?.['status']==='analyzing'"
        >
          <span class="spinner"></span>AI Agent가 읽기 전용 점검 결과를 분석하고
          있습니다.
        </div>
        <ng-container *ngIf="serverAudit() as audit"
          ><div class="audit-summary">
            <span class="badge" [ngClass]="tone(audit['status'])"
              >{{ status(audit['status']) }}</span
            >
            <p>
              {{ audit['summary'] || audit['result'] || '분석 결과를 준비하고
              있습니다.' }}
            </p>
            <small>점검 {{ date(audit['createdAt']) }}</small>
          </div>
          <div class="audit-list" *ngIf="audit['recommendations']?.length">
            <label
              class="audit-item"
              *ngFor="let item of audit['recommendations']"
              [class.selected]="selectedAudit().has(item['code'])"
              ><input
                type="checkbox"
                [checked]="selectedAudit().has(item['code'])"
                (change)="toggleAudit(item['code'])"
                [disabled]="audit['status']!=='ready'"
              /><span
                ><span class="badge" [ngClass]="auditTone(item['severity'])"
                  >{{ item['severity'] }}</span
                ><strong>{{ item['title'] }}</strong
                ><small
                  >{{ item['category'] }} · {{ item['reason'] }}</small
                ></span
              ></label
            >
          </div>
          <div
            class="empty-state compact"
            *ngIf="audit['status']==='ready' && !audit['recommendations']?.length"
          >
            <span class="empty-icon"><wiz-icon name="check"></wiz-icon></span>
            <h3>즉시 적용할 최적화 권고가 없습니다</h3>
            <p>
              분석 시점의 관측 자료에서 안전하게 자동화할 항목을 찾지
              못했습니다.
            </p>
          </div>
          <div class="audit-actions" *ngIf="audit['recommendations']?.length">
            <span>{{ selectedAudit().size }}개 선택</span
            ><button
              class="button primary"
              (click)="confirmOptimizeAudit()"
              [disabled]="!selectedAudit().size || audit['status']!=='ready' || busy()"
            >
              <wiz-icon name="play"></wiz-icon>선택 항목 최적화
            </button>
          </div></ng-container
        >
        <div class="empty-state compact" *ngIf="!serverAudit() && !busy()">
          <span class="empty-icon"><wiz-icon name="spark"></wiz-icon></span>
          <h3>아직 종합 점검을 실행하지 않았습니다</h3>
          <p>분석 시작을 누르면 서버 상태를 읽기 전용으로 수집합니다.</p>
        </div>
      </div>
    </section>
    <wiz-file-browser #fileBrowser
      *ngIf="tab==='files' && (section==='servers'||section==='services')"
      [serverId]="section==='servers'?id:''"
      [serviceId]="section==='services'?id:''"
      [containers]="d['runtime'] || []"
      (composeSelected)="importCompose($event)"
    ></wiz-file-browser>
    <wiz-containers #serverContainers *ngIf="section==='servers' && tab==='containers'" [serverId]="id" [servers]="servers()"></wiz-containers>
    <wiz-terminal
      *ngIf="section==='servers' && tab==='terminal'"
      [serverId]="section==='servers'?id:''"
      [serviceId]="section==='services'?id:''"
      [containers]="d['runtime'] || []"
      [initialComponent]="terminalComponent"
      [label]="section==='services'?'컨테이너 터미널':d['executionMode']==='local'?'로컬 터미널':'SSH 터미널'"
    ></wiz-terminal>
    <section class="panel" *ngIf="tab==='files' && section==='macros'">
      <div class="panel-header">
        <h2>매크로 첨부 파일</h2>
        <label class="button small"
          ><wiz-icon name="upload"></wiz-icon>파일 추가<input
            type="file"
            style="width: 1px; position: absolute; opacity: 0"
            (change)="uploadMacro($event)"
            aria-label="매크로 첨부 파일 업로드"
        /></label>
      </div>
      <div class="table-wrap">
        <table *ngIf="extra().length">
          <thead>
            <tr>
              <th>파일</th>
              <th>크기</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of extra()">
              <td>
                <a class="text-link" [href]="fileUrl(file)" download
                  >{{ file['name'] }}</a
                >
              </td>
              <td>{{ bytes(file['size']) }}</td>
              <td>
                <button
                  class="icon-button"
                  (click)="confirmAction('첨부 파일 삭제',file['name']+' 파일을 매크로에서 제거합니다.','/macros/'+id+'/files/'+file['id'],{},'DELETE')"
                  aria-label="첨부 파일 삭제"
                >
                  <wiz-icon name="trash"></wiz-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-state" *ngIf="!extra().length">
        <h3>첨부한 파일이 없습니다</h3>
        <p>실행에 필요한 1MB 이하 파일을 첨부할 수 있습니다.</p>
      </div>
    </section>
    <section class="panel service-health-panel" *ngIf="tab==='service-health'">
      <div class="panel-header"><h2>HTTP · TCP 상태 점검</h2></div>
      <div class="panel-body service-health-content">
        <div class="notice error" *ngIf="healthHistoryError()" role="alert">{{ healthHistoryError() }}</div>
        <div class="service-health-toolbar">
          <button class="button" [disabled]="busy() || healthWorking" (click)="probeSettings()"><wiz-icon name="settings"></wiz-icon>점검 설정</button>
          <button class="button primary" [disabled]="busy() || healthWorking || !serviceProbeSettings()?.['enabled']" (click)="runServiceHealth()"><wiz-icon name="play"></wiz-icon>{{ healthWorking ? '점검 중…' : '지금 상태 점검' }}</button>
        </div>
        <dl class="definition-list service-probe-summary" *ngIf="serviceProbeSettings() as settings">
          <div><dt>점검 대상</dt><dd>{{ settings['effectiveHost'] || '설정 없음' }}</dd></div>
          <div><dt>HTTP</dt><dd>{{ settings['httpEnabled'] ? settings['httpScheme']+'://'+settings['effectiveHost']+':'+settings['httpPort']+settings['httpPath']+' · 정상 응답 '+settings['expectedStatus'] : '사용 안 함' }}</dd></div>
          <div><dt>TCP</dt><dd>{{ settings['tcpEnabled'] ? settings['effectiveHost']+':'+settings['tcpPort'] : '사용 안 함' }}</dd></div>
        </dl>
        <p class="notice warn" *ngIf="serviceProbeSettings() && !serviceProbeSettings()?.['enabled']">상태 점검이 비활성화되어 있습니다. 점검 설정에서 활성화하세요.</p>
        <div class="service-health-operation" *ngIf="healthOperation() as op" role="status"><span class="badge" [ngClass]="tone(op['status'])">{{ status(op['status']) }}</span><span>{{ op['message'] }}</span><a class="text-link" [routerLink]="'/operations/'+op['id']" target="_blank" rel="noopener noreferrer"><wiz-icon name="file"></wiz-icon>실행 로그<wiz-icon name="external"></wiz-icon></a></div>
        <form class="service-health-search" (ngSubmit)="loadServiceHealth()">
          <label class="field">조회 시작일<input name="healthFrom" type="date" [(ngModel)]="healthDateFrom" /></label>
          <label class="field">조회 종료일<input name="healthTo" type="date" [(ngModel)]="healthDateTo" /></label>
          <label class="field">점검 결과<select name="healthStatus" [(ngModel)]="healthStatus"><option value="">전체 결과</option><option value="healthy">정상</option><option value="unhealthy">비정상</option><option value="unknown">확인 전</option></select></label>
          <button type="submit" class="button" [disabled]="healthHistoryLoading()"><wiz-icon name="search"></wiz-icon>기록 검색</button>
        </form>
        <h3>점검 기록</h3>
        <div class="loading-state" *ngIf="healthHistoryLoading()" role="status"><span class="spinner"></span>점검 기록을 불러오고 있습니다.</div>
        <article class="service-health-result" *ngFor="let row of healthHistory()">
          <header><time>{{ date(row['observedAt']) }}</time><span class="badge" [ngClass]="tone(row['status'])">{{ status(row['status']) }}</span></header>
          <p>{{ row['message'] }}</p><small>재시작 {{ row['restartCount'] }}회 · 연속 실패 {{ row['consecutiveFailures'] }}회</small>
          <details><summary>HTTP · TCP / 컨테이너 세부 결과</summary>
            <div class="table-wrap" *ngIf="row['probes']?.length"><table><thead><tr><th>점검</th><th>결과</th><th>응답 코드</th><th>응답 시간</th></tr></thead><tbody><tr *ngFor="let probe of row['probes']"><td>{{ probe.type.toUpperCase() }}</td><td><span class="badge" [ngClass]="probe.successful ? 'success' : 'danger'">{{ probeStatus(probe.status) }}</span></td><td>{{ probe.statusCode ?? '—' }}</td><td>{{ probe.durationMs }}ms</td></tr></tbody></table></div>
            <p class="small-note" *ngIf="!row['probes']?.length">이 기록에는 HTTP · TCP 점검 결과가 없습니다. 점검 설정을 확인하세요.</p>
            <div class="table-wrap" *ngIf="row['containers']?.length"><table><thead><tr><th>구성요소</th><th>실행 상태</th><th>Health</th><th>healthcheck 설정</th></tr></thead><tbody><tr *ngFor="let container of row['containers']"><td>{{ container.component }}</td><td>{{ runtimeState(container) }}</td><td>{{ runtimeHealth({health:container.dockerHealth}) }}</td><td>{{ healthcheckLabel(container.composeHealthcheck) }}</td></tr></tbody></table></div>
          </details>
        </article>
        <div class="empty-state compact" *ngIf="!healthHistoryLoading() && !healthHistoryError() && !healthHistory().length"><h3>이 서비스의 점검 기록이 없습니다</h3><p>지금 상태 점검을 실행하면 결과가 여기에 표시됩니다.</p></div>
        <button class="button" *ngIf="healthHasMore" [disabled]="healthHistoryLoading()" (click)="loadServiceHealth(true)"><wiz-icon name="history"></wiz-icon>이전 점검 기록 더 보기</button>
      </div>
    </section>

    <ng-container *ngIf="tab==='apache'">
      <section class="panel" *ngFor="let config of extra()">
        <div class="panel-header"><h2>{{ config['name'] }}</h2><button class="button small" (click)="editApache(config)"><wiz-icon name="edit"></wiz-icon>원문 수정</button></div>
        <wiz-code-editor [ngModel]="config['content']" [readonly]="true" language="apache" [rows]="24" label="Apache 프록시 원문"></wiz-code-editor>
      </section>
      <section class="panel empty-state" *ngIf="!extra().length"><span class="empty-icon"><wiz-icon name="globe"></wiz-icon></span><h3>연결된 프록시가 없습니다</h3><p>서비스 도메인을 연결하면 적용 구성을 확인할 수 있습니다.</p></section>
    </ng-container>
    <section class="panel" *ngIf="tab==='environment'" [attr.aria-busy]="environmentLoading()">
      <div class="panel-header">
        <h2>적용된 환경변수</h2>
        <div class="toolbar-right">
          <button class="button small" [class.secret-visible]="revealEnv" (click)="loadEnvironment(!revealEnv)" [disabled]="environmentLoading()"><wiz-icon [name]="revealEnv ? 'eye-off' : 'eye'"></wiz-icon>{{ revealEnv ? '비밀값 숨기기' : '비밀값 표시' }}</button>
          <button class="button small" (click)="copy(json(environment()))" [disabled]="environmentLoading() || !!environmentError() || !environment()['components']?.length"><wiz-icon name="copy"></wiz-icon>전체 JSON 복사</button>
        </div>
      </div>
      <div class="panel-body">
        <div class="loading-state" *ngIf="environmentLoading()" role="status"><span class="spinner"></span>환경변수를 불러오고 있습니다.</div>
        <div class="notice error" *ngIf="!environmentLoading() && environmentError()" role="alert"><span>{{ environmentError() }}</span><button class="button small" (click)="loadEnvironment()">다시 불러오기</button></div>
        <ng-container *ngIf="!environmentLoading() && !environmentError()">
          <details class="environment-component" *ngFor="let component of environment()['components'] || []; trackBy: environmentComponentKey">
            <summary><strong>{{ component.component }}</strong><span class="count-label">{{ keys(component.environment).length }}개 변수</span></summary>
            <div class="environment-component-body">
              <div class="toolbar"><button class="button small" (click)="copy(json(component.environment))"><wiz-icon name="copy"></wiz-icon>구성요소 JSON 복사</button></div>
              <div class="table-wrap" *ngIf="keys(component.environment).length"><table><tbody><tr *ngFor="let key of keys(component.environment)"><td><strong>{{ key }}</strong></td><td class="record-value">{{ component.environment[key] }}</td></tr></tbody></table></div>
              <p class="muted" *ngIf="!keys(component.environment).length">이 구성요소에 적용된 환경변수가 없습니다.</p>
            </div>
          </details>
          <div class="empty-state" *ngIf="!environment()['components']?.length"><h3>조회된 환경변수가 없습니다</h3><p>실행 컨테이너에서 조회된 환경변수가 없습니다. 서비스 배포 상태를 확인하세요.</p></div>
        </ng-container>
      </div>
    </section>

  </ng-container>
</div>
<div #feedbackStack class="feedback-stack" aria-label="작업 상태 및 알림" [attr.inert]="modal() || wizard() || serverConfigurationOpen() ? '' : null">
  <div class="notice error feedback-card" *ngIf="error()" role="alert">
    <wiz-icon name="help"></wiz-icon><span class="feedback-message">{{ error() }}</span
    ><button class="icon-button" aria-label="오류 닫기" (click)="error.set('')">
      <wiz-icon name="close"></wiz-icon>
    </button>
  </div>
  <div class="notice feedback-card operation-feedback" *ngIf="operation() as op" role="status" aria-atomic="true">
    <span class="spinner" aria-hidden="true"></span>
    <span class="badge" [ngClass]="tone(op['status'])">{{ status(op['status']) }}</span>
    <span class="feedback-message">{{ section==='images' ? serverName(op['targetId']) + ' · ' : '' }}{{ op['message'] || '작업이 진행 중입니다.' }}</span>
    <a class="text-link feedback-action" [routerLink]="'/operations/' + op['id']">작업 확인<wiz-icon name="arrow"></wiz-icon></a>
  </div>
  <div class="notice feedback-card" *ngIf="macroExecution() as run" role="status">
    <span class="spinner" *ngIf="macroExecutionWorking" aria-hidden="true"></span>
    <span class="badge" [ngClass]="tone(run['status'])">{{ status(run['status']) }}</span>
    <span class="feedback-message">{{ macroExecutionContext()['name'] }} · {{ macroExecutionContext()['serverName'] }}</span>
    <button class="text-link feedback-action" type="button" (click)="showMacroResult()">실행 결과 보기<wiz-icon name="terminal"></wiz-icon></button>
  </div>
  <ng-container *ngTemplateOutlet="serverContainers()?.feedback || null"></ng-container>
  <ng-container *ngTemplateOutlet="fileBrowser()?.feedback || null"></ng-container>
  <ng-container *ngTemplateOutlet="apacheHost()?.feedback || null"></ng-container>
        <div class="notice agent-maintenance-notice feedback-card" *ngIf="agentMaintenance() as maintenance" role="status">
          <span class="badge" [ngClass]="tone(maintenance['operation']?.status)">{{ status(maintenance['operation']?.status) }}</span>
          <span class="feedback-message">{{ maintenance['operation']?.message || 'Agent 관리 작업을 접수했습니다.' }}</span>
          <button class="text-link feedback-action" (click)="showMaintenance()">작업 확인<wiz-icon name="arrow"></wiz-icon></button>
        </div>

  <div class="toast notice feedback-card" [class.success]="noticeTone()==='success'" [class.error]="noticeTone()==='error'" [class.warn]="noticeTone()==='warn'" *ngIf="notice()" role="status" aria-atomic="true">
    <wiz-icon [name]="noticeTone()==='success' ? 'check' : 'help'"></wiz-icon>
    <span class="feedback-message">{{ notice() }}</span>
    <button type="button" class="icon-button" aria-label="알림 닫기" (click)="notice.set('')"><wiz-icon name="close"></wiz-icon></button>
  </div>
</div>
<div class="modal-backdrop server-configuration-backdrop" *ngIf="serverConfigurationOpen()" [attr.inert]="modal() ? '' : null" [attr.aria-hidden]="modal() ? 'true' : null">
  <section class="modal wide server-configuration-dialog" role="dialog" [attr.aria-modal]="modal() ? null : 'true'" aria-labelledby="server-configuration-title" (keydown)="serverConfigurationKeydown($event)">
    <header class="modal-header" [class.runtime-modal-header]="modal()==='container-logs' || modal()==='container-terminal'"><div><h2 id="server-configuration-title">연결 및 서버 구성</h2><p>SSH 연결 정보와 Docker·실행기·지표 수집 상태를 확인하고 관리합니다.</p></div><button type="button" class="icon-button" aria-label="연결 및 서버 구성 닫기" [disabled]="busy()" (click)="closeServerConfiguration()"><wiz-icon name="close"></wiz-icon></button></header>
      <div class="modal-content server-connection-panel" *ngIf="detail() as d">
        <div class="notice error" role="alert" *ngIf="serverConfigurationError()">{{ serverConfigurationError() }}</div>
        <dl class="definition-list server-configuration-list">
          <div *ngIf="d['executionMode']!=='local'"><dt>SSH 호스트 지문</dt><dd><span>{{ d['fingerprint'] || '승인 필요' }}</span><button class="button small" [disabled]="busy() || !!operation()" (click)="discoverFingerprint(d)"><wiz-icon name="shield"></wiz-icon>호스트 지문 확인</button></dd></div>
          <div *ngIf="d['executionMode']!=='local'"><dt>SSH 개인키</dt><dd><span>{{ d['credentialConfigured'] ? '등록됨' : '등록 필요' }}</span><button class="button small" [disabled]="busy() || !!operation()" (click)="rotateKey()"><wiz-icon name="lock"></wiz-icon>SSH 키 교체</button></dd></div>
          <div><dt>실행기</dt><dd><span>{{ d['executorReady'] ? '준비됨' : '설치 또는 점검 필요' }}<span *ngIf="d['wrapperVersion']"> · {{ d['wrapperVersion'] }}</span></span><button class="button small" *ngIf="d['executionMode']!=='local'" [disabled]="busy() || !!operation() || !d['executorReady']" (click)="confirmAction('실행기 갱신', '승인된 최신 실행기로 갱신합니다. 초기 설치는 자동 구성으로 진행합니다.', '/servers/'+id+'/executor/wrapper')"><wiz-icon name="refresh"></wiz-icon>실행기 갱신</button></dd></div>
          <div><dt>Docker</dt><dd><span>{{ d['dockerReady'] ? '준비됨' : '설치 또는 점검 필요' }}</span><button class="button small" [disabled]="busy() || !!operation() || !d['executorReady']" (click)="confirmAction('Docker 재시작', '이 서버의 Docker를 재시작합니다. 실행 중인 컨테이너에 영향을 줄 수 있습니다.', '/servers/'+id+'/repair', {target:'docker'})"><wiz-icon name="refresh"></wiz-icon>Docker 재시작</button></dd></div>
          <div><dt>지표 수집</dt><dd><span>{{ d['metricAt'] ? date(d['metricAt']) : '아직 수신한 지표 없음' }} · {{ d['executionMode']==='local' ? '관리 콘솔에서 자동 수집' : d['metricAt'] ? '원격 수집기 지표 수신' : '자동 구성 후 지표 수신 확인' }}</span><button class="button small" *ngIf="d['executionMode']!=='local'" [disabled]="busy() || !!operation() || !d['executorReady']" (click)="confirmAction('수집기 재시작', '설치된 지표 수집기를 다시 시작합니다. 자동 구성한 수집 주소로 지표를 전송합니다.', '/servers/'+id+'/repair', {target:'reporter'})"><wiz-icon name="refresh"></wiz-icon>수집기 재시작</button></dd></div>
        </dl>
      </div>
    <footer class="modal-footer"><button type="button" class="button" [disabled]="busy()" (click)="closeServerConfiguration()">닫기</button></footer>
  </section>
</div>
<div class="modal-backdrop" [class.server-configuration-child]="serverConfigurationOpen()" *ngIf="modal()">
  <section
    class="modal console-action-dialog"
    [class.wide]="isMacroEditor || modal()==='compose-editor' || modal()==='compose-image-confirm' || modal()==='compose-history' || modal()==='container-logs' || modal()==='container-terminal' || modal()==='dns-sync' || section==='templates' || modal()==='report' || modal()==='statistics'"
    [class.runtime-tool-modal]="modal()==='container-logs' || modal()==='container-terminal'"
    [class.runtime-tool-fullsize]="runtimeModalFullsize && (modal()==='container-logs' || modal()==='container-terminal')"
    [class.template-editor-modal]="modal()==='template-editor'"
    [class.macro-result-modal]="modal()==='macro-result'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
    (click)="$event.stopPropagation()"
    (keydown)="escape($event)"
  >
    <header class="modal-header">
      <span class="macro-modal-mark" *ngIf="modal()==='macro-result'" aria-hidden="true"><wiz-icon name="terminal"></wiz-icon></span>
      <div [class.macro-header-copy]="modal()==='macro-result'">
        <h2 id="modal-title">{{ modalTitle }}</h2>
        <p>{{ modalDescription }}</p>
      </div>
      <div class="modal-header-actions">
        <button type="button" class="icon-button" *ngIf="modal()==='container-logs' || modal()==='container-terminal'" (click)="toggleRuntimeSize()" [attr.aria-pressed]="runtimeModalFullsize" [attr.aria-label]="runtimeModalFullsize ? '기본 크기' : '전체 크기'" [attr.title]="runtimeModalFullsize ? '기본 크기' : '전체 크기'"><wiz-icon [name]="runtimeModalFullsize ? 'layout' : 'external'"></wiz-icon></button>
        <button class="icon-button" (click)="closeModal()" [disabled]="busy()" aria-label="닫기" title="닫기"><wiz-icon name="close"></wiz-icon></button>
      </div>
    </header>
    <ng-container *ngIf="modal()==='container-logs'">
      <div class="modal-content runtime-tool-content">
        <div class="notice error" *ngIf="modalError()" role="alert">{{ modalError() }}</div>
        <div class="runtime-log-toolbar">
          <label class="log-follow-toggle"><input type="checkbox" role="switch" [ngModel]="followLogs" (ngModelChange)="setLogFollow($event)" /><span>자동 갱신 ({{ logRefreshInterval / 1000 }}초)</span></label>
          <div class="runtime-log-actions">
            <label class="log-follow-toggle"><input type="checkbox" role="switch" [ngModel]="showLogTimestamps" (ngModelChange)="setLogTimestamps($event)" /><span>시간 표시 (KST)</span></label>
            <button type="button" class="button small" [disabled]="logsLoading()" (click)="loadLogs()"><wiz-icon name="refresh"></wiz-icon>새로고침</button>
            <button type="button" class="button small" [disabled]="!logSnapshot()" (click)="copy(logSnapshot())"><wiz-icon name="copy"></wiz-icon>로그 복사</button>
          </div>
        </div>
        <div class="loading-state" *ngIf="logsLoading() && !logsLoaded" role="status"><span class="spinner"></span>로그를 불러오고 있습니다.</div>
        <div #runtimeLogOutput class="code-block runtime-log-output" tabindex="0" aria-label="컨테이너 로그 출력">
          <div class="runtime-log-line" *ngFor="let line of logLines()"><time class="log-timestamp" *ngIf="showLogTimestamps && line.timestamp" [attr.datetime]="line.timestamp" [attr.title]="line.timestamp + ' · 한국 시간 (KST)'">{{ line.timeLabel }}</time><span>{{ line.message }}</span></div>
          <span *ngIf="!logSnapshot() && !logsLoading()">최근 출력된 로그가 없습니다.</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="modal()==='container-terminal'">
      <div class="modal-content runtime-tool-content runtime-terminal-content"><wiz-terminal [serviceId]="id" [containers]="detail()?.['runtime'] || []" [initialComponent]="terminalComponent" [embedded]="true" [compact]="true" [fixedComponent]="true" [autoConnect]="true" label="컨테이너 터미널"></wiz-terminal></div>
    </ng-container>
    <form *ngIf="modal()==='compose-image-confirm'" (ngSubmit)="saveServiceCompose(true)" class="service-compose-form">
      <div class="modal-content"><h3>Compose 이미지 변경 확인</h3><p>다음 이미지 변경을 저장합니다. 저장 후 배포하면 해당 컨테이너가 새 이미지로 생성됩니다.</p>
        <div class="notice error" *ngIf="modalError()" role="alert">{{ modalError() }}</div>
        <div class="table-wrap"><table><thead><tr><th>구성요소</th><th>이전 이미지</th><th>변경 이미지</th></tr></thead><tbody><tr *ngFor="let change of composeImageChanges()"><td>{{ change.component }}</td><td>{{ change.before || '없음' }}</td><td>{{ change.after || '삭제됨' }}</td></tr></tbody></table></div>
        <div class="loading-state" *ngIf="busy()" role="status"><span class="spinner"></span>변경한 구성을 저장하고 있습니다.</div>
      </div><footer class="modal-footer"><button type="button" class="button" [disabled]="busy()" (click)="modal.set('compose-editor');modalError.set('')">편집으로 돌아가기</button><button type="submit" class="button primary" [disabled]="busy()">{{ busy() ? '저장 중…' : '이미지 변경 확인 · 저장' }}</button></footer>
    </form>
    <ng-container *ngIf="modal()==='compose-history'">
      <div class="modal-content"><div class="notice error" *ngIf="modalError()" role="alert">{{ modalError() }}</div><div class="loading-state" *ngIf="versionLoading()" role="status"><span class="spinner"></span>구성 이력을 불러오고 있습니다.</div>
        <ng-container *ngIf="versionContent() as version">
          <div class="toolbar"><button class="button small" (click)="versionCompare=!versionCompare">{{ versionCompare ? 'Compose 원문 보기' : '이전 구성과 비교' }}</button><button class="button small" *ngIf="versionCompare && version.previousVersion" (click)="copy(version.before)"><wiz-icon name="copy"></wiz-icon>이전 구성 복사</button><button class="button small" (click)="copy(version.after)"><wiz-icon name="copy"></wiz-icon>Compose 복사</button></div>
          <p *ngIf="versionCompare">{{ version.previousVersion ? '이전 v'+version.previousVersion : '최초 구성' }} → v{{ version.version }}</p>
          <wiz-code-diff *ngIf="versionCompare" [before]="version.before" [after]="version.after" label="Compose 변경 비교"></wiz-code-diff>
          <wiz-code-editor *ngIf="!versionCompare" [ngModel]="version.after" [readonly]="true" language="yaml" [rows]="23" label="저장된 Compose 원문"></wiz-code-editor>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="modal()==='preflight'">
      <div class="modal-content">
        <div class="notice error" *ngIf="modalError()" role="alert">{{ modalError() }}</div>
        <div class="loading-state" *ngIf="busy()" role="status"><span class="spinner"></span>배포 준비 상태를 점검하고 있습니다.</div>
        <div class="check-list" *ngIf="!busy() && preflight() as p">
          <span class="badge" [ngClass]="p['ready'] ? 'success' : 'warning'">{{ p['ready'] ? '배포 준비 완료' : '확인 필요' }}</span>
          <div class="check-row" [class.failed]="!check.passed" *ngFor="let check of p['checks']"><wiz-icon [name]="check.passed ? 'check' : 'help'"></wiz-icon><div><strong>{{ check.name }}</strong><small>{{ check.message }}</small></div></div>
        </div>
      </div>
      <footer class="modal-footer"><button class="button" [disabled]="busy()" (click)="closeModal()">닫기</button><button class="button primary" [disabled]="busy()" (click)="checkService()"><wiz-icon name="refresh"></wiz-icon>다시 점검</button></footer>
    </ng-container>
    <form class="service-compose-form" *ngIf="modal()==='compose-editor'" (ngSubmit)="saveServiceCompose()">
      <div class="modal-content">
        <div class="loading-state" *ngIf="busy()" role="status"><span class="spinner"></span>Compose 변경을 확인하고 저장하고 있습니다.</div>
        <div class="loading-state" *ngIf="composeLoading()" role="status"><span class="spinner"></span>비밀값을 포함한 Compose 원문을 불러오고 있습니다.</div>
        <div class="notice error" *ngIf="composeLoadError() || modalError()" role="alert">{{ composeLoadError() || modalError() }}</div>
        <wiz-code-editor *ngIf="!composeLoading() && !composeLoadError()" name="serviceCompose" [(ngModel)]="form['compose']" language="yaml" [rows]="23" [tabIndent]="true" [readonly]="busy()" label="Compose 구성 편집"></wiz-code-editor>
      </div>
      <footer class="modal-footer"><button type="button" class="button" [disabled]="busy()" (click)="closeModal()">취소</button><button type="button" class="button" *ngIf="composeLoadError()" (click)="editServiceCompose()">다시 불러오기</button><button type="submit" class="button primary" [disabled]="busy() || composeLoading() || !!composeLoadError()"><wiz-icon name="save"></wiz-icon>{{ busy() ? '저장 중…' : '구성 저장' }}</button></footer>
    </form>
    <form *ngIf="modal()==='template-editor'" (ngSubmit)="saveTemplateEditor()" class="template-editor-form" novalidate>
      <nav class="template-editor-tabs" aria-label="템플릿 편집 항목">
        <button type="button" *ngFor="let item of templateSections" [class.active]="templateEditorTab===item.id" [attr.aria-pressed]="templateEditorTab===item.id" (click)="templateEditorTab=item.id"><wiz-icon [name]="item.icon"></wiz-icon>{{ item.label }}</button>
      </nav>
      <div class="modal-content template-editor-content" [class.template-input-content]="templateEditorTab==='template-inputs'" [class.template-code-content]="templateEditorTab==='compose' || templateEditorTab==='template-apache'">
        <div class="notice error template-editor-error" *ngIf="modalError()" role="alert">{{ modalError() }}</div>
        <fieldset [disabled]="busy()" class="template-editor-fields">
          <section class="template-editor-card" *ngIf="templateEditorTab==='overview'">
            <h3>기본 정보</h3><div class="form-grid">
            <label class="field">템플릿 ID <span class="required">*</span><input name="templateId" [(ngModel)]="templateDraft['id']" [readonly]="templateEditorExisting" maxlength="80" placeholder="예: my-template" /><small>영문 소문자, 숫자, 하이픈 · 저장 후 변경할 수 없습니다.</small></label>
            <label class="field">이름 <span class="required">*</span><input name="templateName" [(ngModel)]="templateDraft['name']" maxlength="120" /></label>
            <label class="field span-full">설명<textarea name="templateDescription" [(ngModel)]="templateDraft['description']" rows="5" placeholder="어떤 서비스를 위한 템플릿인지 간단히 설명하세요."></textarea></label>
            <label class="field span-full">분류<input name="templateTags" [(ngModel)]="templateDraft['tags']" placeholder="예: development, database" /><small>여러 분류는 쉼표로 구분합니다.</small></label>
            <label class="template-enabled span-full"><input type="checkbox" name="templateEnabled" [(ngModel)]="templateDraft['enabled']" />서비스 생성에 사용</label>
            </div>
          </section>
          <section class="template-editor-card" *ngIf="templateEditorTab==='overview'">
            <h3>사용 안내</h3>
            <p class="template-section-intro">서비스를 만드는 사람이 확인할 안내입니다. 항목별로 작성하면 같은 순서로 표시됩니다.</p>
            <div class="template-instruction-editor" *ngFor="let note of templateDraft['instructions']; let i=index; trackBy: instructionIndex">
              <label class="field">안내 {{ i + 1 }}<textarea [name]="'instruction'+i" [(ngModel)]="templateDraft['instructions'][i]" rows="3"></textarea></label>
              <button type="button" class="icon-button" [attr.aria-label]="'안내 '+(i+1)+' 삭제'" (click)="templateDraft['instructions'].splice(i,1)"><wiz-icon name="trash"></wiz-icon></button>
            </div>
            <button type="button" class="button" (click)="templateDraft['instructions'].push('')"><wiz-icon name="plus"></wiz-icon>안내 추가</button>
          </section>
          <wiz-template-input-editor [hidden]="templateEditorTab!=='template-inputs'" [(inputs)]="templateDraft['inputs']" [(selectedIndex)]="templateInputSelectedIndex"></wiz-template-input-editor>
          <div class="template-code-section" *ngIf="templateEditorTab==='compose'">
            <div class="template-code-options">
            <p class="template-section-intro">컨테이너 실행 구성을 작성합니다. 입력 설정의 key를 이 구성에서 사용하세요.</p>
            <div class="form-grid template-endpoint-fields">
              <label class="field">기본 연결 구성요소<input name="templateEndpointService" [(ngModel)]="templateDraft['endpointService']" placeholder="예: app · 선택 사항" /><small>도메인을 연결할 Compose 서비스 이름입니다. 비우면 기본 연결을 지정하지 않습니다.</small></label>
              <label class="field">내부 포트<input type="number" name="templateEndpointPort" [(ngModel)]="templateDraft['endpointPort']" min="1" max="65535" placeholder="예: 8080" /></label>
            </div>
            <p class="template-editor-shortcuts">Tab: 공백 2칸 들여쓰기 · Ctrl+M: Tab 포커스 이동 전환 (macOS: Ctrl+Shift+M)</p>
            </div>
            <wiz-code-editor [fill]="true" [tabIndent]="true" name="templateCompose" [readonly]="busy()" [(ngModel)]="templateDraft['compose']" language="yaml" [rows]="21" label="docker-compose.yaml 편집"></wiz-code-editor>
          </div>
          <div class="template-code-section" *ngIf="templateEditorTab==='template-apache'">
            <div class="template-code-options">
            <div class="template-editor-section-header"><p>새 서비스의 도메인 연결에 사용할 HTTP VirtualHost입니다.</p><button type="button" class="button small" (click)="apacheTemplateAssist=!apacheTemplateAssist" [attr.aria-expanded]="apacheTemplateAssist"><wiz-icon name="spark"></wiz-icon>AI Agent 도우미</button></div>
            <details class="template-apache-guide"><summary>자동 설정되는 값과 수정 가능한 항목</summary>
              <dl><div><dt>도메인</dt><dd><code [textContent]="'ServerName {{ domain }}'"></code> · 연결한 서비스 도메인을 사용합니다.</dd></div><div><dt>프록시 대상</dt><dd><code [textContent]="'http://{{ target_host }}:{{ target_port }}/'"></code> · 배포 서버와 서비스 포트를 사용합니다.</dd></div><div><dt>HTTP / HTTPS</dt><dd>템플릿은 <code>&lt;VirtualHost *:80&gt;</code> 하나를 작성합니다. 443 리스너·인증서 경로·HTTPS 리디렉션은 도메인 연결 시 자동 생성합니다.</dd></div><div><dt>프록시 방식</dt><dd><code>ProxyRequests Off</code>가 기본입니다. 서비스 대상만 중계하며 forward proxy는 켜지 않습니다.</dd></div><div><dt>수정 가능</dt><dd>ProxyPreserveHost, RequestHeader, Header, LimitRequestBody, Timeout, ProxyTimeout, AllowEncodedSlashes 및 ProxyPass 옵션. 외부 Include와 다른 지시문은 이 템플릿에서 지원하지 않습니다.</dd></div></dl>
              <p>기본 업로드 제한은 104857600바이트(100 MiB), ProxyPass timeout은 300초입니다. 새 템플릿에서 Apache2를 비우면 기본 설정을 사용합니다.</p>
            </details>
            <div class="template-apache-ai" *ngIf="apacheTemplateAssist">
              <label class="field">새로 작성하거나 수정할 내용<input name="apachePrompt" [(ngModel)]="apacheTemplatePrompt" [disabled]="apacheTemplateBusy()" placeholder="예: 응답 대기를 600초로 늘려줘" /></label>
              <button type="button" class="button" [disabled]="apacheTemplateBusy()" (click)="assistTemplateApache()"><wiz-icon name="spark"></wiz-icon>{{ apacheTemplateBusy() ? '작성 중…' : 'AI로 작성 · 수정' }}</button>
              <p class="small-note">작성 결과를 편집기에서 검토한 후 변경 사항을 저장하세요.</p>
            </div>
            <p class="notice" role="status" *ngIf="apacheTemplateError()">{{ apacheTemplateError() }}</p>
            <p class="template-editor-shortcuts">Tab: 공백 2칸 들여쓰기 · Ctrl+M: Tab 포커스 이동 전환 (macOS: Ctrl+Shift+M)</p>
            </div>
            <wiz-code-editor [fill]="true" [tabIndent]="true" name="templateApache" [(ngModel)]="apacheTemplateContent" [readonly]="apacheTemplateBusy() || busy()" [rows]="21" language="apache" label="템플릿 Apache2 설정"></wiz-code-editor>
          </div>
        </fieldset>
      </div>
      <footer class="modal-footer"><button class="button" type="button" (click)="closeModal()" [disabled]="busy()">취소</button><button class="button primary" type="submit" [disabled]="busy() || apacheTemplateBusy()"><wiz-icon name="save"></wiz-icon>{{ busy() ? '저장 중…' : templateEditorExisting ? '변경 저장' : '템플릿 저장' }}</button></footer>
    </form>
    <form
      *ngIf="modal()==='form' || modal()==='confirm' || modal()==='prune' || modal()==='migration-review'"
      (ngSubmit)="saveForm()"
      style="display: contents"
    >
      <div class="modal-content">
        <div class="macro-run-summary" *ngIf="isMacroRun && macroRunSelection() as selected">
          <strong>{{ selected['name'] }}</strong><span class="badge">v{{ selected['version'] }}</span>
          <p *ngIf="selected['description']">{{ selected['description'] }}</p>
        </div>
        <div class="notice error" *ngIf="modalError()" role="alert">
          <wiz-icon name="help"></wiz-icon>{{ modalError() }}
        </div>
        <ng-container *ngIf="isServiceDomainEdit && selectedServiceDomain as link">
          <dl class="definition-list service-domain-summary">
            <div><dt>현재 연결 상태</dt><dd><span class="badge" [ngClass]="tone(link['state'])">{{ link['state']==='awaiting-deploy' ? '배포 대기' : status(link['state']) }}</span></dd></div>
            <div><dt>프록시 대상</dt><dd>{{ link['target_host'] }}:{{ link['target_port'] }}</dd></div>
            <div><dt>Cloudflare Zone</dt><dd>{{ form['zoneName'] }}</dd></div>
          </dl>
        </ng-container>
        <div class="notice warn" *ngIf="modal()==='confirm'">
          <wiz-icon name="shield"></wiz-icon>대상과 영향을 확인했습니다. 아래
          실행 버튼을 누르면 작업이 시작됩니다.
        </div>
        <ng-container *ngIf="modal()==='migration-review'"
          ><dl class="definition-list">
            <div>
              <dt>현재 서버</dt>
              <dd>{{ serverName(migrationPreview()?.['sourceServerId']) }}</dd>
            </div>
            <div>
              <dt>대상 서버</dt>
              <dd>{{ serverName(migrationPreview()?.['targetServerId']) }}</dd>
            </div>
          </dl>
          <div class="check-list" style="margin: 17px 0">
            <div
              class="check-row"
              [class.failed]="!check.passed"
              *ngFor="let check of migrationPreview()?.['checks']"
            >
              <wiz-icon [name]="check.passed ? 'check' : 'help'"></wiz-icon>
              <div>
                <strong>{{ check.name }}</strong
                ><small>{{ check.message }}</small>
              </div>
            </div>
          </div>
          <details>
            <summary class="text-link">전송 대상 데이터 확인</summary>
            <pre class="code-block">
{{ json(migrationPreview()?.['inventory']) }}</pre
            >
          </details>
          <div class="notice warn" style="margin-top: 18px">
            <wiz-icon name="help"></wiz-icon>데이터를 최종 동기화하는 동안
            서비스가 중단됩니다. 체크섬과 대상 서버의 상태를 확인하며 실패 시
            원래 서버로 복구합니다.
          </div>
          <label class="field"
            ><span class="checkbox-label"
              ><input
                type="checkbox"
                name="maintenanceConfirmed"
                [(ngModel)]="form['maintenanceConfirmed']"
              />전송 대상과 서비스 중단 시간을 확인했습니다.</span
            ></label
          ></ng-container
        ><ng-container *ngIf="modal()==='prune'">
          <div class="notice" *ngIf="pruneLoading()" role="status"><span class="spinner"></span>{{ pruneMode==='versions' ? '이미지 버전을' : '미사용 이미지를' }} 조회하고 있습니다.</div>
          <ng-container *ngIf="!pruneLoading() && prunePreview()">
            <div class="summary-strip">
              <span>{{ pruneMode==='versions' ? '버전' : '미사용' }} <b>{{ pruneCandidates.length }}개</b></span>
              <span>삭제 선택 <b>{{ selectedPruneImages().size }}개</b></span>
              <span>선택 용량 <b>{{ bytes(pruneSelectedBytes) }}</b></span>
            </div>
            <label class="prune-select-all" *ngIf="pruneCandidates.length">
              <input type="checkbox" [checked]="allPruneSelected" [indeterminate]="selectedPruneImages().size>0 && !allPruneSelected" [disabled]="busy()" (change)="togglePrune()" />삭제 가능한 이미지 전체 선택
            </label>
            <div class="check-list prune-list">
              <label class="check-row" *ngFor="let image of pruneCandidates" [class.prune-protected]="pruneCandidateBlocked(image)">
                <input type="checkbox" class="row-checkbox" [checked]="selectedPruneImages().has(image['digest'])" [disabled]="busy() || pruneCandidateBlocked(image)" (change)="togglePrune(image)" [attr.aria-label]="pruneCandidateLabel(image)+' 삭제 선택'" />
                <div><strong>{{ pruneMode==='versions' ? imageVersions(image) : imageRef(image) }}</strong><small>{{ pruneMode==='versions' ? imageRef(image)+' · ' : imageVersions(image)+' · ' }}{{ bytes(image['size']) }} · {{ date(image['created']) }}</small>
                  <small *ngIf="image['protected']">배포·롤백 이력에서 보호 중 · 삭제 제외</small>
                  <small *ngIf="!image['protected'] && imageUsed(image)">사용 중인 버전 · 삭제 제외</small>
                </div>
              </label>
            </div>
            <p *ngIf="!pruneCandidates.length" class="small-note">{{ pruneMode==='versions' ? '선택할 이미지 버전이 없습니다.' : '정리할 미사용 이미지가 없습니다.' }}</p>
            <p class="small-note">체크한 {{ pruneMode==='versions' ? '버전' : '이미지' }}만 삭제합니다. 실행 직전에 사용 여부와 보호 상태를 다시 확인합니다. 공유 레이어로 인해 실제 확보 용량은 선택 용량보다 작을 수 있습니다.</p>
          </ng-container>
        </ng-container>
        <div
          class="toggle-filter image-transfer-toggle"
          *ngIf="modal()==='form' && imageTransferMode"
          role="group"
          aria-label="이미지 가져오기 방식"
        >
          <button
            type="button"
            [class.active]="imageTransferMode==='registry'"
            [attr.aria-pressed]="imageTransferMode==='registry'"
            (click)="setImageTransferMode('registry')"
          >레지스트리에서 가져오기</button
          ><button
            type="button"
            [class.active]="imageTransferMode==='file'"
            [attr.aria-pressed]="imageTransferMode==='file'"
            (click)="setImageTransferMode('file')"
          >tar 파일 가져오기</button>
        </div>
        <div class="report-settings" *ngIf="modal()==='form' && actionEndpoint==='/anomaly-reports/settings'">
          <div class="field">
            <span id="report-stage-label">분석 단계</span>
            <div class="toggle-filter report-stage-toggle" role="group" aria-labelledby="report-stage-label">
              <button *ngFor="let preset of reportPresets" type="button" [class.active]="form['thresholdPreset']===preset['id']"
                [attr.aria-pressed]="form['thresholdPreset']===preset['id']" [disabled]="busy()"
                (click)="form['thresholdPreset']=preset['id'];applyReportPreset()">{{ preset['label'] }}</button>
              <button type="button" [class.active]="form['thresholdPreset']==='manual'" [attr.aria-pressed]="form['thresholdPreset']==='manual'"
                [disabled]="busy()" (click)="form['thresholdPreset']='manual'">수동</button>
            </div>
            <small>민감: 빠른 감지 / 균형: 일반 운영 / 여유: 지속된 큰 변화. 수동에서 값을 직접 수정합니다.</small>
          </div>
          <label class="field" for="report-recipients">리포트 수신자
            <textarea id="report-recipients" name="recipients" [(ngModel)]="form['recipients']" rows="4"
              placeholder="ops@example.com&#10;admin@example.com" [disabled]="busy()"></textarea>
            <small>한 줄에 이메일 주소를 하나씩 입력하세요. 최대 30명까지 설정할 수 있습니다.</small>
          </label>
          <div class="report-threshold-grid">
            <div class="field" *ngFor="let field of fields; trackBy: fieldKey">
              <div class="report-setting-label">
                <label [for]="'report-'+field.key">{{ field.label }}</label>
                <span class="report-help" *ngIf="field.hint">
                  <button type="button" [attr.aria-label]="field.label+' 설명'" [attr.aria-describedby]="'report-help-'+field.key">?</button>
                  <span class="report-help-popover" role="tooltip" [id]="'report-help-'+field.key">{{ field.hint }}</span>
                </span>
              </div>
              <input [id]="'report-'+field.key" [name]="field.key" type="number" [(ngModel)]="form[field.key]"
                [readonly]="reportThresholdReadOnly(field.key)" [disabled]="busy()" required
                [min]="field.key==='minCoveragePercent' ? 0 : field.key.endsWith('Threshold') && field.key!=='failureThreshold' ? 0.1 : 1"
                [max]="field.key==='sustainedMinutes' ? 1440 : 100" [step]="field.key==='failureThreshold' || field.key==='sustainedMinutes' ? 1 : 'any'" />
            </div>
          </div>
        </div>
        <div class="form-grid" *ngIf="modal()==='form' && actionEndpoint!=='/anomaly-reports/settings'">
          <label
            class="field"
            [class.span-full]="(isServiceDomainEdit && field.key==='name') || (isMacroRun && field.key==='serverId') || actionEndpoint==='/auth/password' || field.type==='textarea' || field.type==='file' || field.type==='checkbox' || (fields.length<3 && !isMacroRun)"
            *ngFor="let field of visibleFields; trackBy: fieldKey"
            >{{ field.label }}<span class="required" *ngIf="field.required"
              >*</span
            ><wiz-code-editor
              *ngIf="field.type==='textarea'"
              [name]="field.key"
              [(ngModel)]="form[field.key]"
              [rows]="field.rows || 5"
              [language]="editorLanguage(field)"
              [label]="field.label"
              [required]="!!field.required"
              [disabled]="isMacroEditor && macroEditorLoading()"
            ></wiz-code-editor
            ><select
              *ngIf="field.type==='select'"
              [name]="field.key"
              [(ngModel)]="form[field.key]"
              (ngModelChange)="changedField(field.key)"
              [disabled]="!!field.disabled || (isMacroEditor && macroEditorLoading())"
              [required]="!!field.required"
            >
              <option value="">{{ field.placeholder || '선택해 주세요' }}</option>
              <option
                *ngFor="let option of field.options; trackBy: optionKey"
                [value]="option.value"
              >
                {{ option.label }}
              </option></select
            ><input
              *ngIf="field.type==='file'"
              class="file-input"
              type="file"
              (change)="uploadField($event,field.key)"
              [attr.aria-label]="field.label"
            /><span *ngIf="field.type==='checkbox'" class="checkbox-label"
              ><input
                type="checkbox"
                [name]="field.key"
                [(ngModel)]="form[field.key]"
                (ngModelChange)="isServiceDomainEdit && changedField(field.key)"
              />{{ form[field.key] ? '선택됨' : '선택 안 됨' }}</span
            ><input
              *ngIf="!['textarea','select','file','checkbox'].includes(field.type || '')"
              [type]="field.type || 'text'"
              [name]="field.key"
              [readonly]="reportThresholdReadOnly(field.key)"
              [disabled]="!!field.disabled || (isMacroEditor && macroEditorLoading())"
              [placeholder]="field.placeholder || ''"
              [(ngModel)]="form[field.key]"
              (ngModelChange)="field.key==='cron' && previewSchedule()"
              [required]="!!field.required"
              [attr.autocomplete]="field.key==='currentPassword' ? 'current-password' : field.type==='password' ? 'new-password' : 'off'"
            /><small class="service-domain-preview" *ngIf="isServiceDomainEdit && field.key==='name'">연결 도메인: {{ form['name']==='@' ? form['zoneName'] : form['name']+'.'+form['zoneName'] }}</small><small *ngIf="field.hint">{{ field.hint }}<ng-container *ngIf="actionEndpoint==='/auth/password' && field.key==='newPassword'"> · 현재 {{ passwordLength(form[field.key]) }}자</ng-container></small
            ><button
              type="button"
              class="button small"
              *ngIf="field.key==='fingerprint' && actionEndpoint==='/servers'"
              (click)="discoverNewFingerprint()"
              [disabled]="busy() || !form['host']"
            >
              <wiz-icon name="search"></wiz-icon>SSH 지문 조회</button
            ><button
              class="text-link"
              type="button"
              style="margin-top: 10px"
              *ngIf="field.key==='compose' && section==='services' && id"
              (click)="revealCompose()"
              [disabled]="busy()"
            >
              <wiz-icon name="eye"></wiz-icon>보안 값을 포함해 기존 구성
              불러오기</button
            ><small *ngIf="field.key==='cron' && actionEndpoint.startsWith('/schedules')" class="schedule-preview" aria-live="polite">
              <span *ngIf="schedulePreviewPending()">다음 실행 확인 중…</span>
              <span *ngIf="schedulePreview()">다음 실행: {{ schedulePreview() }}</span>
              <span class="required" *ngIf="schedulePreviewError()">{{ schedulePreviewError() }}</span>
            </small><span
              class="toolbar-left"
              style="margin-top: 9px"
              *ngIf="field.key==='cron'"
              ><button
                type="button"
                class="button small"
                (click)="quickCron('0 0 9 * * ?')"
              >
                <wiz-icon name="calendar"></wiz-icon>매일 09:00</button
              ><button
                type="button"
                class="button small"
                (click)="quickCron('0 0 9 ? * MON')"
              >
                <wiz-icon name="calendar"></wiz-icon>매주 월요일</button
              ><button
                type="button"
                class="button small"
                (click)="quickCron('0 0 9 1 * ?')"
              >
                <wiz-icon name="calendar"></wiz-icon>매월 1일
              </button></span
            ></label
          >
        </div>
        <p class="notice warn" *ngIf="isMacroRun && macroTargetsError()" role="alert">{{ macroTargetsError() }} 목록을 다시 불러오려면 서버를 다시 선택하세요. 서버 직접 실행은 가능합니다.</p>
        <ng-container *ngIf="isMacroEditor">
          <section class="macro-attachments" aria-label="매크로 첨부파일 편집">
            <div class="macro-section-header"><h3>첨부파일</h3><label class="button small"><wiz-icon name="upload"></wiz-icon>파일 추가<input class="file-input" type="file" multiple (change)="stageMacroFiles($event)" [disabled]="busy() || macroEditorLoading()" aria-label="매크로 첨부파일 추가" /></label></div>
            <p class="muted">파일당 1MB, 전체 2MB, 최대 20개. 실행 경로에서 ./파일명으로 참조하세요. 실행 후 스크립트와 복사된 파일은 삭제됩니다.</p>
            <p class="muted" *ngIf="macroEditorLoading()">첨부파일을 불러오는 중…</p>
            <p class="notice error" *ngIf="macroEditorLoadError()" role="alert">{{ macroEditorLoadError() }} 편집 모달을 다시 열어 주세요.</p>
            <ul class="macro-file-list" *ngIf="macroEditorFiles().length">
              <li *ngFor="let file of macroEditorFiles()"><span>{{ file['name'] }} <small>{{ bytes(file['size']) }}</small></span><button class="icon-button" type="button" (click)="removeMacroDraftFile(file)" [disabled]="busy() || macroEditorLoading()" [attr.aria-label]="file['name']+' 첨부 제거'" title="첨부 제거"><wiz-icon name="trash"></wiz-icon></button></li>
            </ul>
            <p class="muted" *ngIf="!macroEditorLoading() && !macroEditorFiles().length">첨부파일이 없습니다.</p>
          </section>
          <section class="macro-agent" aria-label="매크로 Agent 작성">
            <h3><wiz-icon name="spark"></wiz-icon>Agent 스크립트 작성</h3>
            <label class="field">작성·수정 요청<textarea name="macroAgentPrompt" [(ngModel)]="macroAgentPrompt" rows="3" placeholder="예: 첨부한 config.json을 읽어 설정을 확인하는 스크립트를 만들어줘" [disabled]="macroAgentBusy() || busy()"></textarea></label>
            <button class="button small" type="button" (click)="requestMacroAgent()" [disabled]="macroAgentBusy() || macroEditorLoading() || busy()"><wiz-icon name="spark"></wiz-icon>{{ macroAgentBusy() ? 'Agent 작성 중…' : 'Agent에 작성 요청' }}</button>
            <p class="notice error" *ngIf="macroAgentError()" role="alert">{{ macroAgentError() }}</p>
            <div class="macro-agent-result" *ngIf="macroAgentResult() as result">
              <p>{{ result.summary }}</p><pre>{{ result.script }}</pre>
              <button class="button small" type="button" (click)="applyMacroAgent()" [disabled]="busy()">스크립트에 적용</button>
            </div>
            <small class="muted">현재 스크립트와 첨부파일 이름을 전달합니다. 초안을 적용한 후 검토하고 저장하세요.</small>
          </section>
        </ng-container>
      </div>
      <footer class="modal-footer">
        <button
          *ngIf="isDnsZoneEditForm"
          class="button danger zone-delete-button"
          type="button"
          (click)="confirmZoneDelete()"
          [disabled]="busy()"
        >
          <wiz-icon name="trash"></wiz-icon>연결 해제
        </button>
        <button
          class="button"
          type="button"
          (click)="closeModal()"
          [disabled]="busy()"
        >
          <wiz-icon name="close"></wiz-icon>취소</button
        ><button
          class="button"
          [class.danger]="actionMethod==='DELETE' || modal()==='prune'"
          [class.primary]="actionMethod!=='DELETE' && modal()!=='prune'"
          type="submit"
          [disabled]="busy() || (isMacroEditor && (macroEditorLoading() || !!macroEditorLoadError())) || (isMacroRun && macroTargetsLoading()) || (modal()==='form' && actionEndpoint.startsWith('/schedules') && (schedulePreviewPending() || !!schedulePreviewError())) || (modal()==='migration-review' && (!form['maintenanceConfirmed'] || !migrationPreview()?.['ready'])) || (modal()==='prune' && (pruneLoading() || !selectedPruneImages().size))"
        >
          <wiz-icon name="save"></wiz-icon
          ><span class="spinner" *ngIf="busy()"></span>{{ busy() ? '처리 중…' :
          modal()==='prune' ? '선택 '+selectedPruneImages().size+'개 삭제' : modal()==='confirm' ||
          modal()==='migration-review' ?
          '확인하고 실행' : submitLabel }}
        </button>
      </footer>
    </form>
    <ng-container *ngIf="modal()==='dns-sync'">
      <div class="modal-content dns-sync-content">
        <div class="notice error" role="alert" *ngIf="modalError()">{{ modalError() }}</div>
        <p *ngIf="dnsSyncLoading()" role="status"><span class="spinner"></span>Cloudflare 전체 레코드와 변경 내용을 조회하고 있습니다.</p>
        <ng-container *ngIf="dnsSyncPreview() as preview">
          <h3>{{ preview['zoneName'] }}</h3>
          <div class="summary-strip sync-counts"><span>추가 <b>{{ preview['added'] }}</b></span><span>변경 <b>{{ preview['updated'] }}</b></span><span>삭제 <b>{{ preview['deleted'] }}</b></span><span>서비스 연결 보존 <b>{{ preview['protectedCount'] }}</b></span><span>동일 <b>{{ preview['unchanged'] }}</b></span></div>
          <p class="small-note">Cloudflare {{ preview['remoteCount'] }}개 조회. 미리보기 이후 값이 바뀌면 적용을 중단하고 다시 확인합니다.</p>
          <div class="table-wrap" *ngIf="preview['changes'].length"><table class="sync-changes"><thead><tr><th>반영</th><th>레코드</th><th>변경 내용</th></tr></thead><tbody>
            <tr *ngFor="let change of preview['changes']"><td><span class="badge" [ngClass]="change['action']==='delete' ? 'danger' : change['action']==='protect' ? 'warning' : 'info'">{{ change['action']==='add' ? '추가' : change['action']==='update' ? '변경' : change['action']==='delete' ? '삭제' : '연결 보존' }}</span></td><td><strong>{{ (change['after'] || change['before'])['name'] }}</strong><small>{{ (change['after'] || change['before'])['type'] }}</small></td><td><pre>{{ change['details'] }}</pre></td></tr>
          </tbody></table></div>
          <p *ngIf="!preview['changes'].length">변경할 레코드가 없습니다. 영역 정보와 마지막 동기화 시간을 갱신합니다.</p>
          <h4>영역 정보</h4><pre class="sync-zone-changes">{{ preview['zoneChanges'] }}</pre>
        </ng-container>
      </div>
      <footer class="modal-footer"><button type="button" class="button" [disabled]="busy()" (click)="closeModal()">취소</button><button type="button" class="button primary" [disabled]="busy() || dnsSyncLoading() || !dnsSyncPreview()" (click)="applyDnsSync()">확인한 변경 적용</button></footer>
    </ng-container>
    <ng-container *ngIf="modal()==='macro-result'">
      <div class="modal-content macro-result-content" *ngIf="macroExecution() as run">
        <section class="macro-result-overview">
          <div class="macro-run-summary">
            <span class="macro-result-eyebrow">실행한 매크로</span>
            <div class="macro-result-title"><strong>{{ macroExecutionContext()['name'] }}</strong><span class="badge">v{{ macroExecutionContext()['version'] }}</span></div>
            <p *ngIf="macroExecutionContext()['description']">{{ macroExecutionContext()['description'] }}</p>
          </div>
          <div class="macro-result-status" [ngClass]="tone(run['status'])" role="status">
            <span class="macro-status-mark" aria-hidden="true"><span class="spinner" *ngIf="macroExecutionWorking"></span><wiz-icon *ngIf="!macroExecutionWorking" [name]="run['status']==='succeeded' ? 'check' : run['status']==='failed' ? 'close' : 'stop'"></wiz-icon></span>
            <div><strong>{{ status(run['status']) }}</strong><p>{{ run['message'] }}</p></div>
          </div>
          <dl class="macro-result-meta">
            <div><dt><wiz-icon name="server"></wiz-icon>실행 서버</dt><dd>{{ macroExecutionContext()['serverName'] }}</dd></div>
            <div><dt><wiz-icon name="layers"></wiz-icon>실행 대상</dt><dd>{{ macroExecutionContext()['containerName'] || '서버에서 직접 실행' }}<small *ngIf="macroExecutionContext()['serviceName']">{{ macroExecutionContext()['serviceName'] }}</small></dd></div>
          </dl>
        </section>
        <p class="notice error macro-result-alert" role="alert" *ngIf="macroExecutionError()">{{ macroExecutionError() }}</p>
        <div class="macro-result-logs">
          <section class="macro-log-panel">
            <header><h3><wiz-icon name="terminal"></wiz-icon>표준 출력</h3><span class="macro-log-channel">STDOUT</span></header>
            <pre class="code-block macro-result-output" [class.macro-output-empty]="!macroOutput('stdout')" aria-label="매크로 표준 출력" tabindex="0">{{ macroOutput('stdout') || (macroExecutionWorking ? '실행이 끝나면 출력이 표시됩니다.' : '표준 출력이 없습니다.') }}</pre>
          </section>
          <section class="macro-log-panel macro-error-panel" [class.has-output]="!!macroOutput('stderr')">
            <header><h3><wiz-icon name="help"></wiz-icon>오류 출력</h3><span class="macro-log-channel">STDERR</span></header>
            <pre class="code-block macro-result-output" [class.macro-output-empty]="!macroOutput('stderr')" aria-label="매크로 오류 출력" tabindex="0">{{ macroOutput('stderr') || '오류 출력이 없습니다.' }}</pre>
          </section>
        </div>
        <details class="macro-result-events" *ngIf="macroExecutionEvents.length">
          <summary><span><wiz-icon name="history"></wiz-icon>진행 로그 <span class="macro-event-count">{{ macroExecutionEvents.length }}</span></span><wiz-icon name="down"></wiz-icon></summary>
          <ol><li *ngFor="let event of macroExecutionEvents"><span class="macro-event-dot" [ngClass]="tone(event['level'])"></span><div><time>{{ date(event['createdAt']) }}</time><pre>{{ event['message'] }}</pre></div></li></ol>
        </details>
      </div>
      <footer class="modal-footer macro-result-footer"><span class="muted" *ngIf="macroExecutionWorking"><wiz-icon name="clock"></wiz-icon>닫아도 실행은 계속됩니다.</span><button class="button primary" type="button" (click)="closeModal()">닫기</button></footer>
    </ng-container>
    <div class="modal-content" *ngIf="modal()==='runs'">
      <div class="check-list">
        <div class="check-row" *ngFor="let run of extra()">
          <span class="badge" [ngClass]="tone(run['status'])"
            >{{ status(run['status']) }}</span
          >
          <div>
            <strong>{{ date(run['createdAt'] || run['fired_at']) }}</strong
            ><small>{{ run['message'] }}</small
            ><a
              class="text-link"
              *ngIf="run['operationId'] || run['operation_id'] || (section==='macros' && run['id'])"
              [routerLink]="'/operations/'+(run['operationId'] || run['operation_id'] || run['id'])"
              (click)="closeModal()"
              ><wiz-icon name="history"></wiz-icon>실행 결과 보기</a
            ><small
              *ngIf="!run['operationId'] && !run['operation_id'] && section!=='macros'"
              >작업 접수 전 결과입니다.</small
            >
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="!extra().length">
        <h3>실행 이력이 없습니다</h3>
      </div>
    </div>
    <div class="modal-content" *ngIf="modal()==='health'">
      <div class="check-list">
        <div
          class="check-row"
          [class.failed]="row['status']!=='healthy'"
          *ngFor="let row of extra()"
        >
          <span class="badge" [ngClass]="tone(row['status'])"
            >{{ status(row['status']) }}</span
          >
          <div>
            <strong>{{ row['serviceName'] }}</strong
            ><small>{{ row['message'] }} · {{ date(row['observedAt']) }}</small
            ><small
              >재시작 {{ row['restartCount'] }}회 · 연속 실패 {{
              row['consecutiveFailures'] }}회</small
            >
          </div>
        </div>
      </div>
      <div class="empty-state" *ngIf="!extra().length">
        <h3>아직 관측한 서비스가 없습니다</h3>
        <p>지금 상태 점검을 실행하거나 예약 작업을 설정해 주세요.</p>
      </div>
    </div>
    <div class="modal-content" *ngIf="modal()==='agent-maintenance'">
      <div class="notice error" *ngIf="modalError()">{{ modalError() }}</div>
      <span
        class="badge"
        [ngClass]="tone(agentMaintenance()?.['operation']?.status)"
        >{{ status(agentMaintenance()?.['operation']?.status) }}</span
      >
      <p class="small-note">{{ agentMaintenance()?.['operation']?.message }}</p>
      <ng-container
        *ngIf="agentMaintenance()?.['verificationUri'] && agentMaintenance()?.['userCode']"
        ><label class="field" style="margin-top: 20px"
          >기기 로그인 코드<input
            readonly
            [value]="agentMaintenance()?.['userCode']"
        /></label>
        <div class="toolbar-left">
          <a
            class="button primary"
            [href]="agentMaintenance()?.['verificationUri']"
            target="_blank"
            rel="noopener noreferrer"
            >로그인 페이지 열기<wiz-icon name="external"></wiz-icon></a
          ><button
            class="button"
            (click)="copy(agentMaintenance()?.['userCode'])"
          >
            <wiz-icon name="copy"></wiz-icon>코드 복사
          </button>
        </div>
        <p class="small-note">
          {{ date(agentMaintenance()?.['expiresAt']) }}까지 사용할 수 있습니다.
        </p></ng-container
      >
      <div class="toolbar-left" style="margin-top: 20px">
        <a
          class="button"
          [routerLink]="'/operations/'+agentMaintenance()?.['operation']?.id"
          (click)="closeModal()"
          ><wiz-icon name="history"></wiz-icon>작업 기록</a
        ><button
          class="button danger"
          [disabled]="busy() || ['succeeded','failed','canceled'].includes(agentMaintenance()?.['operation']?.status)"
          (click)="cancelMaintenance()"
        >
          <wiz-icon name="close"></wiz-icon>작업 취소
        </button>
      </div>
    </div>
    <div class="modal-content" *ngIf="modal()==='statistics'">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>수집 시각</th>
              <th>CPU 최소 / 평균 / 최대</th>
              <th>메모리 최소 / 평균 / 최대</th>
              <th>스토리지 최소 / 평균 / 최대</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of metricStats()">
              <td>
                {{ date(row['recordedAt']) }}<small
                  >{{ row['samples'] }}건</small
                >
              </td>
              <td>
                {{ percent(row['cpu_min']) }} / {{ percent(row['cpu_avg']) }} /
                {{ percent(row['cpu_max']) }}
              </td>
              <td>
                {{ percent(row['memory_min']) }} / {{ percent(row['memory_avg'])
                }} / {{ percent(row['memory_max']) }}
              </td>
              <td>
                {{ percent(row['storage_min']) }} / {{
                percent(row['storage_avg']) }} / {{ percent(row['storage_max'])
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-state" *ngIf="!metricStats().length">
        <h3>선택 기간에 수집한 지표가 없습니다</h3>
      </div>
    </div>
    <div class="modal-content" *ngIf="modal()==='bulk-result'">
      <div class="check-list">
        <div
          class="check-row"
          [class.failed]="!!result.error"
          *ngFor="let result of editing?.['results']"
        >
          <wiz-icon [name]="result.error ? 'help' : 'check'"></wiz-icon>
          <div>
            <strong>{{ result.serviceId }}</strong
            ><small *ngIf="result.error">{{ result.error }}</small
            ><a
              class="text-link"
              *ngIf="result.operation"
              [routerLink]="'/operations/'+result.operation.id"
              (click)="closeModal()"
              >{{ status(result.operation.status) }} · 작업 보기<wiz-icon
                name="arrow"
              ></wiz-icon
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-content report-document" *ngIf="modal()==='report'">
      <p class="report-document-message" role="status" *ngIf="!reportDocument() && !reportDocumentError()">리포트를 불러오고 있습니다.</p>
      <p class="report-document-message notice danger" role="alert" *ngIf="reportDocumentError()">{{ reportDocumentError() }}</p>
      <iframe *ngIf="reportDocument()" sandbox="" [srcdoc]="reportDocument()" title="운영 리포트 본문"></iframe>
    </div>
  </section>
</div>
<div class="modal-backdrop" *ngIf="wizard()">
  <section
    class="modal wide service-wizard"
    role="dialog"
    aria-modal="true"
    aria-labelledby="wizard-title"
    (click)="$event.stopPropagation()"
    (keydown)="escape($event)"
  >
    <header class="modal-header">
      <div>
        <h2 id="wizard-title">새 서비스 만들기</h2>
        <p>구성을 선택하고 실행 환경을 확인한 후 배포합니다.</p>
      </div>
      <button
        class="icon-button"
        (click)="closeWizard()"
        [disabled]="busy()"
        aria-label="서비스 생성 닫기"
      >
        <wiz-icon name="close"></wiz-icon>
      </button>
    </header>
    <nav class="wizard-steps" aria-label="서비스 생성 단계">
      <button type="button" *ngFor="let label of wizardSteps;let index=index" [class.current]="step===index+1" [class.done]="furthestStep>index+1"
        [disabled]="!canVisitWizardStep(index+1)" [attr.aria-current]="step===index+1?'step':null" (click)="wizardGo(index+1)"><b>{{ index+1 }}</b>{{ label }}</button>
    </nav>
    <div class="modal-content">
      <div class="notice error" role="alert" *ngIf="modalError()">
        <wiz-icon name="help"></wiz-icon>{{ modalError() }}
      </div>
      <ng-container *ngIf="step===1"
        ><div class="tabs">
          <button
            [class.active]="source==='template'"
            (click)="source='template';wizardChanged()"
          >
            <wiz-icon name="plus"></wiz-icon>템플릿으로 만들기</button
          ><button [class.active]="source==='manual'" (click)="source='manual';wizardChanged()">
            <wiz-icon name="layout"></wiz-icon>고급 · Compose 직접 입력
          </button>
        </div>
        <ng-container *ngIf="source==='template'"
          ><p class="wizard-caption">사용할 서비스 구성을 선택하세요.</p>
          <div class="choice-grid">
            <button
              class="choice"
              *ngFor="let t of templates()"
              [disabled]="!t['enabled']"
              [class.selected]="selectedTemplate===t['id']"
              (click)="chooseTemplate(t)"
            >
              <wiz-icon name="layout"></wiz-icon><strong>{{ t['name'] }}</strong
              ><small
                >{{ t['description'] || t['tags']?.join(' · ') || '입력값을
                설정해 서비스를 만듭니다.' }}</small
              ><span class="badge" *ngIf="!t['enabled']">비활성</span>
            </button>
          </div>
          <button
            class="button full"
            *ngIf="templateHasMore"
            style="margin-top: 14px"
            (click)="moreTemplates()"
            [disabled]="busy()"
          >
            <wiz-icon name="layout"></wiz-icon>템플릿 더 보기
          </button>
          <div class="empty-state" *ngIf="!templates().length">
            <span class="empty-icon"><wiz-icon name="layout"></wiz-icon></span>
            <h3>사용할 템플릿이 없습니다</h3>
            <p>
              템플릿을 먼저 만들거나 고급 흐름에서 Compose를 직접 입력하세요.
            </p>
            <a class="button" routerLink="/templates" (click)="closeWizard()"
              ><wiz-icon name="layout"></wiz-icon>템플릿 관리</a
            >
          </div></ng-container
        >
        <div class="notice" *ngIf="source==='manual'">
          <wiz-icon name="file"></wiz-icon>다음 단계에서 Compose 원문을
          입력합니다. 이미지, 포트와 로컬 볼륨은 사전 점검에서 다시 확인합니다.
        </div></ng-container
      >
      <ng-template #templateInput let-input>
        <div class="field">
          <label [attr.for]="'template-input-'+input.key">{{ input.label || input.key }}<span class="required" *ngIf="input.required && !input.generate">*</span></label>
          <select *ngIf="input.type==='enum'" [id]="'template-input-'+input.key" [(ngModel)]="values[input.key]" (ngModelChange)="wizardChanged()">
            <option *ngFor="let option of input.options || input.values" [value]="option">{{ option }}</option>
          </select>
          <div class="template-boolean" *ngIf="input.type==='boolean'">
            <input type="checkbox" [id]="'template-input-'+input.key" [(ngModel)]="values[input.key]" (ngModelChange)="wizardChanged()" />
            <span>{{ values[input.key] ? '사용' : '사용 안 함' }}</span>
          </div>
          <div class="template-value" *ngIf="!['enum','boolean'].includes(input.type)">
            <input [id]="'template-input-'+input.key" [type]="input.type==='secret' && !revealedInputs[input.key] ? 'password' : input.type==='number' ? 'number' : 'text'"
              [(ngModel)]="values[input.key]" (ngModelChange)="wizardChanged()" [attr.min]="input.minimum" [attr.max]="input.maximum" [attr.step]="input.integer ? 1 : null"
              [attr.aria-describedby]="input.description ? 'template-hint-'+input.key : null"
              [attr.autocomplete]="input.type==='secret' ? 'new-password' : 'off'" [placeholder]="input.generate ? '자동 생성 ('+input.minimum+'~'+input.maximum+')' : input.label || input.key" />
            <button *ngIf="input.type==='secret'" class="icon-button secret-toggle" [class.revealed]="revealedInputs[input.key]" type="button" [attr.title]="(input.label || input.key)+(revealedInputs[input.key] ? ' 숨기기' : ' 표시')" [attr.aria-label]="(input.label || input.key)+(revealedInputs[input.key] ? ' 숨기기' : ' 표시')"
              [attr.aria-pressed]="!!revealedInputs[input.key]" (click)="revealedInputs[input.key]=!revealedInputs[input.key]"><wiz-icon [name]="revealedInputs[input.key] ? 'eye-off' : 'eye'"></wiz-icon></button>
          </div>
          <small *ngIf="input.description" [id]="'template-hint-'+input.key">{{ input.description }}</small>
        </div>
      </ng-template>
      <ng-container *ngIf="step===2">
        <p class="wizard-caption" *ngIf="source==='template'">{{ selectedTemplateObject?.['name'] }} · 필수 항목만 입력하면 기본 구성으로 시작합니다.</p>
        <div class="wizard-settings-grid" [class.with-guide]="source==='template' && selectedTemplateObject?.['instructions']?.length"><div class="wizard-settings-fields">
        <label class="field">서비스 이름<span class="required">*</span>
          <input [(ngModel)]="draft['name']" (ngModelChange)="wizardChanged()" placeholder="예: my-spring-app" maxlength="80" aria-describedby="service-name-hint" />
          <small id="service-name-hint">영문 소문자, 숫자, 하이픈으로 2~80자 입력하세요.</small>
        </label>
        <ng-container *ngIf="source==='template'">
          <ng-container *ngFor="let input of templateFields(selectedTemplateObject)">
            <ng-container *ngTemplateOutlet="templateInput; context: {$implicit: input}"></ng-container>
          </ng-container>
          <p class="small-note">비밀번호는 미리보기에서 숨기며, 서비스 저장 시 암호화합니다.</p>
          <details class="wizard-options" *ngIf="templateFields(selectedTemplateObject,true).length">
            <summary>고급 설정 <span>포트 등 기본값 변경</span></summary>
            <ng-container *ngFor="let input of templateFields(selectedTemplateObject,true)">
              <ng-container *ngTemplateOutlet="templateInput; context: {$implicit: input}"></ng-container>
            </ng-container>
          </details>

        </ng-container>
        <label class="field" *ngIf="source==='manual'">Compose 구성<span class="required">*</span>
          <wiz-code-editor [(ngModel)]="draft['compose']" (ngModelChange)="wizardChanged()" [rows]="15" language="yaml" label="Compose 구성"></wiz-code-editor>
        </label>
        </div><aside class="wizard-template-guide" *ngIf="source==='template' && selectedTemplateObject?.['instructions']?.length">
          <h3>템플릿 사용 안내</h3><ul class="template-instructions"><li *ngFor="let note of selectedTemplateObject?.['instructions']">{{ note }}</li></ul>
        </aside></div>
      </ng-container>
      <ng-container *ngIf="step===3"
        ><p class="wizard-caption">서비스를 실행할 서버를 직접 선택하세요.</p>
        <div class="notice">
          <wiz-icon name="shield"></wiz-icon>24시간·7일 평균으로 계산한 점수를 각각 50% 반영합니다. 점수가 낮을수록 여유가 있는 후보입니다. 준비되지 않았거나 지표가 오래된 서버는 선택할 수 없습니다.
        </div>
        <div class="choice-grid">
          <button
            class="choice server-choice"
            *ngFor="let s of servers()"
            [disabled]="!s['eligible']"
            [class.selected]="draft['serverId']===s['id']"
            (click)="draft['serverId']=s['id'];wizardChanged()"
          >
            <span class="server-choice-name"
              >{{ s['name'] }}
              <span
                class="badge"
                [ngClass]="s['eligible'] ? 'success' : 'neutral'"
                >{{ s['eligible'] ? '배포 가능' : '준비 필요' }}</span
              ></span
            ><small>{{ s['host'] }} · 배포 점수 <b>{{ s['score'] ?? '집계 대기' }}</b></small>
            <ng-container *ngTemplateOutlet="deploymentWindows; context: {$implicit:s}"></ng-container>
            <small *ngFor="let reason of s['exclusionReasons']"
              >{{ reason }}</small
            >
          </button>
        </div>
        <div class="empty-state" *ngIf="!servers().length">
          <h3>연결된 서버가 없습니다</h3>
          <p>서버를 먼저 연결하고 지문과 실행 환경을 점검해 주세요.</p>
          <a class="button" routerLink="/servers" (click)="closeWizard()"
            ><wiz-icon name="server"></wiz-icon>서버 관리</a
          >
        </div></ng-container
      >
      <ng-container *ngIf="step===4">
        <p class="wizard-caption">새 DNS 레코드와 Apache2 설정을 함께 추가합니다.</p>
        <label class="domain-enable"><input type="checkbox" [(ngModel)]="draft['domainEnabled']" (ngModelChange)="wizardChanged();draft['domainEnabled'] && loadWizardDomains()" />도메인 연결</label>
        <p class="small-note" *ngIf="!draft['domainEnabled']">도메인 없이도 서비스를 만들 수 있습니다.</p>
        <ng-container *ngIf="draft['domainEnabled']">
          <p role="status" *ngIf="wizardDomainLoading()">도메인 설정을 불러오는 중…</p>
          <div class="notice error" role="alert" *ngIf="wizardDomainError()">{{ wizardDomainError() }}<button class="button" (click)="loadWizardDomains()">다시 조회</button></div>
          <div class="form-grid">
            <label class="field">Cloudflare Zone<select [(ngModel)]="draft['zoneId']" [class.input-placeholder]="!draft['zoneId']" (ngModelChange)="wizardZone()"><option value="">영역 선택</option><option *ngFor="let zone of zones()" [value]="zone['id']">{{ zone['name'] }}</option></select></label>
            <label class="field">새 도메인 이름<input [(ngModel)]="draft['domain']" (ngModelChange)="wizardChanged()" placeholder="app.example.com" /></label>
            <label class="field">DNS 연결 주소<select [(ngModel)]="draft['dnsContent']" (ngModelChange)="wizardChanged()" [class.input-placeholder]="!draft['dnsContent']" [disabled]="wizardDomainLoading() || !wizardDnsAddresses().length"><option value="">연결 주소 선택</option><option *ngFor="let address of wizardDnsAddresses()" [value]="address">{{ address }}</option></select><small>Apache 서버로 연결되는 IPv4 주소를 선택하세요.</small></label>
          </div>
          <p class="notice" *ngIf="!wizardDomainLoading() && !wizardDomainError() && !wizardDnsAddresses().length">등록된 IPv4 연결 주소가 없습니다. <a routerLink="/system" [queryParams]="{tab:'dns'}" (click)="closeWizard()" class="text-link">시스템 설정에서 IPv4 주소를 등록하세요.</a></p>
          <p class="notice" *ngIf="source==='template' && selectedTemplateObject?.['publicEndpoint']?.service">배포 후 {{ selectedTemplateObject?.['publicEndpoint'].service }}의 실제 공개 포트로 자동 연결합니다. 템플릿의 Apache2 설정을 기본으로 사용합니다.</p>
          <div class="form-grid" *ngIf="source==='manual' || !selectedTemplateObject?.['publicEndpoint']?.service">
            <label class="field">프록시 대상 주소<input [(ngModel)]="draft['targetHost']" (ngModelChange)="wizardChanged()" placeholder="비워 두면 선택 서버 주소" /></label>
            <label class="field">프록시 대상 호스트 포트<input type="number" min="1" max="65535" [(ngModel)]="draft['targetPort']" (ngModelChange)="wizardChanged()" /></label>
          </div>
          <p class="small-note">사전 점검 시 선택한 주소에 맞는 DNS 레코드와 Apache2 대기 설정을 추가합니다. 배포 후 DNS 확인과 인증서 자동 발급을 마치면 HTTPS로 연결합니다. 같은 이름의 기존 레코드는 사용하지 않습니다. 서비스·DNS 삭제 시 인증서와 해당 인증서의 자동 갱신 설정도 함께 정리됩니다.</p>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="step===5"
        ><p class="wizard-caption">
          선택한 구성을 확인하고 사전 점검을 실행하세요.
        </p>
        <dl class="definition-list">
          <div>
            <dt>서비스 이름</dt>
            <dd>{{ draft['name'] }}</dd>
          </div>
          <div>
            <dt>실행 서버</dt>
            <dd>{{ serverName(draft['serverId']) }}</dd>
          </div>
          <div>
            <dt>도메인</dt>
            <dd>{{ draft['domainEnabled'] ? draft['domain'] : '연결 안 함' }}</dd>
          </div>
        </dl>
        <details style="margin: 18px 0">
          <summary class="text-link">Compose 구성 확인</summary>
          <pre class="code-block" style="margin-top: 12px">
{{ draft['compose'] }}</pre
          >
        </details>
        <div class="check-list" *ngIf="preflight() as p">
          <div
            class="check-row"
            [class.failed]="!check.passed"
            *ngFor="let check of p['checks']"
          >
            <wiz-icon [name]="check.passed ? 'check' : 'help'"></wiz-icon>
            <div>
              <strong>{{ check.name }}</strong
              ><small>{{ check.message }}</small>
            </div>
          </div>
        </div>
        <div
          class="notice success"
          *ngIf="step===5 && preflight()?.['ready']"
          style="margin-top: 17px"
        >
          <wiz-icon name="check"></wiz-icon>사전 점검을 통과했습니다. 선택한
          서버에 배포할 수 있습니다.
        </div>
        <p class="small-note" *ngIf="!preflight()">
          사전 점검을 시작하면 서비스 초안이 저장됩니다. 배포는 아래 배포 버튼을
          누른 후 시작됩니다.
        </p></ng-container
      >
    </div>
    <footer class="modal-footer">
      <span class="footer-left">{{ step }} / 5 단계</span
      ><button
        class="button"
        *ngIf="step>1"
        (click)="wizardGo(step-1)"
        [disabled]="busy()"
      >
        <wiz-icon name="back"></wiz-icon>이전</button
      ><button class="button" (click)="closeWizard()" [disabled]="busy()">
        <wiz-icon name="save"></wiz-icon>{{ savedDraft ? '초안 저장 후 닫기' :
        '취소' }}</button
      ><button
        class="button primary"
        *ngIf="step<5 || !preflight()?.['ready']"
        (click)="wizardNext()"
        [disabled]="busy()"
      >
        <span class="spinner" *ngIf="busy()"></span>{{ busy() ? '점검 중…' :
        step===5 ? '초안 저장 · 사전 점검' : '다음' }}<wiz-icon
          name="arrow"
          *ngIf="!busy()"
        ></wiz-icon></button
      ><button
        class="button primary"
        *ngIf="step===5 && preflight()?.['ready']"
        (click)="deployDraft()"
        [disabled]="busy() || !draft['serverId']"
      >
        <wiz-icon name="play"></wiz-icon
        ><span class="spinner" *ngIf="busy()"></span>선택한 서버에 배포
      </button>
    </footer>
  </section>
</div>

<ng-template #deploymentWindows let-server let-compact="compact">
            <span class="server-resource-window" *ngFor="let period of server['deploymentWindows']">
              <span class="server-window-heading">{{ period.hours === 24 ? '최근 24시간' : '최근 7일' }} 평균
                <small>표본 {{ period.sampleCount }}건 · 수집 범위 {{ period.observedHours }}시간</small>
              </span>
              <span class="server-window-metrics" [class.compact]="compact">
                <span>CPU <b>{{ percent(period.cpuPercent) }}</b></span>
                <span>메모리 <b>{{ percent(period.memoryPercent) }}</b></span>
                <span>스토리지 <b>{{ percent(period.storagePercent) }}</b></span>
                <span *ngIf="!compact">점수 <b>{{ period.score ?? '—' }}</b></span>
              </span>
              <small *ngIf="period.sampleCount < 2">집계 대기 · 서로 다른 시각의 표본이 2건 이상 필요합니다.</small>
            </span>
</ng-template>
